export const languageContent = {
  English: {
    payments: 'Payments',
    down_payment: 'Down Payment',
    paying_tax_investing_somewhere: 'Paying the tax and investing somewhere else',
    paying_tax_at_period_end: 'Paying tax at period end',
    tax: 'Tax',
    pay_installment_cost: 'Pay installment cost',
    pay_indexing_cost: 'Pay indexing cost',
    gradual_payment: 'Gradual Payment',
    pay: 'Pay',
    target_irr: 'Target IRR',
    real_estate_irr: 'Real Estate IRR',
    irr: 'IRR',
    irr_no_reconstruction: 'IRR in case there is no reconstruction',
    net_yearly_return_on_rent: 'Net yearly return on rent',
    yearly_return_from_rent: 'Yearly return from rent',
    return_cashflow: 'Expected Return (Cash Flow)',
    total_roi: 'Total roi',
    return_appreciation: 'Expected Return (Appreciation)',
    bad: 'Bad',
    current_scenario: 'Current Scenario',
    good: 'Good',
    original: 'Original',
    armageddon: 'Armageddon',
    armageddon_scenario: 'Armageddon Scenario',
    margin_ceiling: 'Margin Ceiling',
    real_estate_holding_period: 'Real estate holding period',
    real_estate_holding_period_months: 'Real estate holding period (months)',
    grace_period: 'Grace Period',
    configure: 'Configure',
    role: 'Role',
    description: 'Description',
    expected_cashflow: 'Expected Cashflow',
    cashflow: 'Cashflow',
    multi_generational: 'Multi-generational',
    strategic_planning: 'Strategic planning',
    frequency: 'Frequency',
    end_date_calculated_automatically: 'End date calculated automatically?',
    start_date_calculated_automatically: 'Start date calculated automatically?',
    end_date: 'End Date',
    date: 'Date',
    added_on: 'Added On',
    start_date: 'Start Date',
    share_with_new_user: 'Share with new user',
    show_general_info_to_client: 'Show General Info To Client?',
    share_strategies: 'Share Strategies',
    share: 'Share',
    annuity: 'Annuity',
    yearly: 'Yearly',
    buying_year: 'Buying Year',
    end_year: 'End Year',
    selling_year: 'Selling Year',
    start_year: 'Start Year',
    configure_armageddon: 'Configure Armageddon',
    change: 'Change',
    year: 'Year',
    kept_remaining_cash: 'Kept remaining cash <b>{amount}</b>',
    saving_cashflow_changes: 'Saving cashflow changes',
    maintain_margin: 'Maintain margin',
    save: 'Save',
    secondary_name: 'Secondary Name',
    realtor_seller_name: 'Realtor/ seller name + phone number',
    name: 'Name',
    name_optional: 'Name (Optional)',
    parameters: 'Parameters',
    show_apartments_for: 'Show apartments for',
    sent_remaining_cash: 'Sent remaining cash <b>{amount}</b> to linked bank account <b>{accountName}</b>',
    welcome_to_ETICA_financials: 'Hello! Welcome to Ethica Finance',
    welcome_message: 'Welcome to Ethica Finance',
    public_signup: 'Create account',
    public_signup_heading: 'Create account',
    public_signup_intro_hint:
      'After you submit this form, you will receive an email with an invitation link to set your password.',
    signup_success_verify_email:
      'Account created. Check your email for links to verify your email and set your password, then sign in.',
    phone_number_public_signup: 'Phone',
    name_required_short: 'Please enter your name.',
    phone_required_short: 'Please enter your phone number.',
    invalid_email_short: 'Please enter a valid email address.',
    signup_brand_headline: 'Hello! Welcome to Etica Finance',
    signup_brand_tagline: 'Building clarity for your financial future.',
    signup_all_fields_required: 'All fields are required.',
    login_brand_headline: 'Welcome back to Ethica Finance',
    login_brand_tagline: 'Secure sign-in to your wealth planning workspace.',
    reset_password_brand_headline: 'Choose a new password',
    reset_password_brand_tagline: 'Secure your account with a strong password—you will sign in next.',
    get_started_brand_headline: 'Begin with Ethica Finance',
    get_started_brand_tagline: 'Share your details and we will email you a link to create your password.',
    rent: 'Rent',
    clone_strategy: 'Clone Strategy {strategy}',
    clone: 'Clone',
    duplicate: 'Duplicate',
    mark_several_strategies: 'Mark several strategies',
    strategies_marked: '{count} strategies selected',
    are_you_sure_to_move_these_strategies_to_sandbox:
      'Are you sure you want to move these strategies to the sandbox?',
    are_you_sure_to_move_these_strategies_to_mainbox:
      'Are you sure you want to move these strategies to the main box?',
    rent_pre_construction: 'Rent Pre Construction',
    monthly_rent_post_construction: 'Monthly Rent Post Construction',
    rent_post_construction: 'Rent Post Construction',
    total_income_from_rent_minus_monthly_payment: 'Total income from rent minus total monthly payments',
    total_rent: 'Total Rent',
    return_cashflow_monthly: 'Expected Monthly Cashflow',
    monthly_rent: 'Monthly rent',
    rent_during_contruction: 'Rent During Construction (default is as pre- demolition)',
    forgot_password: 'Forgot password?',
    marginal_rate_of_income: 'Marginal rate of income',
    capital_appreciation_tax: 'Capital appreciation tax',
    one_off_change: 'One Off Change',
    interest_rate_changes: 'Interest Rate Changes',
    one_off_change_by: 'One off change by',
    heads_up: 'Heads Up!',
    update_start_date_note_for_strategies:
      'Please note, This will update the start month and year of each strategy in the customer.',
    area_in_square_meters: 'Area In Square Meters',
    unarchive: 'Unarchive',
    saving_variable: 'Saving Variable',
    saving_admin: 'Saving Admin',
    saving_taxbrackets: 'Saving Tax Bracket',
    saving_customer: 'Saving Customer',
    saving_preset: 'Saving Preset',
    archiving_strategy: 'Archiving strategy',
    future_value_pre_tax: 'Future value pre-tax',
    net_value: 'Net value',
    total_value: 'Total value',
    value_of_stocks_with_marginal_tax_rate: 'Value of stocks with marginal tax rate',
    value_of_stocks_with_capital_aprreciation_tax_rate: 'Value of stocks with capital aprreciation tax rate',
    value_of_received_apartment_today: 'Value of received apartment today',
    value_after_renovation: 'Value after renovation',
    appreciation: 'Appreciation',
    margin_floor: 'Margin Floor',
    level: 'Level',
    level_to: 'Level To',
    buying: 'Buying',
    mortgage_interest: 'Mortgage interest',
    interest: 'Interest',
    loan_interest: 'Loan Interest',
    profit_from_selling_brfore_tax: 'Profit from selling (before tax)',
    profit_from_selling_after_tax: 'Profit from selling (after tax)',
    total_net_profit: 'Total net profit',
    monthly_net_profit: 'Monthly net profit',
    profit_at_excersising_pre_tax: 'Profit at excersising pre tax',
    profit: 'Profit',
    pensioni: 'Pensioni',
    quaterly: 'Quaterly',
    asset_name: 'Link Asset',
    link_a_new_liability: 'Link a new liability',
    stock_KSH: 'stock KSH',
    video_link: 'Video Link',
    total_loan_decrease: 'Total loan decrease',
    asset_category: 'Asset Category',
    category: 'Asset Category',
    apartment_floor_number: "Apartment's floor number",
    files_from_drive: 'Files From Drive',
    other_files: 'Other Files',
    set_a_ceiling_value: 'Set a ceiling value',
    set_a_floor_value: 'Set a floor value',
    set: 'Set',
    get_reset_email: 'Get Reset Email',
    fixed: 'Fixed',
    view_files: 'View Files',
    view_profile: 'View Profile',
    yearly_growth_rate: 'Yearly Growth Rate (%)',
    balance_sheet_growth_with_time: 'Balance Sheet Growth With Time',
    add_new_strategy: 'Add New Strategy',
    viewing_user: 'Viewing User',
    open_drive_folder: 'Open Drive Folder',
    profile_details: 'Profile Details',
    difference: 'Difference',
    active: 'Active',
    actions: 'Actions',
    edit_mode: 'Edit Mode',
    buy_mode: 'Buy Mode',
    add_mode: 'Add Mode',
    add_mode_tooltip:
      'Changes to each asset or liability will not affect other assets or liabilities (intended for building an existing state, not for building possible scenarios)',
    buy_mode_tooltip:
      'Changes to each asset or liability affect the overall balance sheet (buying an asset will reduce the balance from another cash account in the portfolio)',
    action: 'Action',
    filters: 'Filters',
    stock_portfolio: 'stock portfolio',
    end_value: 'End value',
    monthly_value: 'Monthly Value',
    initial_value: 'Initial Value',
    value: 'Value',
    edit: 'Edit',
    yearly_appreciation: 'Yearly appreciation',
    annual_appreciation: 'Annual Appreciation',
    costs: 'Costs',
    expected_value_appreciation_from_change: 'Expected Value Appreciation From Additional Costs',
    expected_appreciation: 'Expected Appreciation',
    value_added_by_renovation: 'Value Added by Renovation',
    do_we_need_to_pay_material_cost_index: 'Do we need to pay material cost index?',
    renovation_cost: 'Renovation cost',
    total_deal_cost: 'Total deal cost',
    cost_of_retailer_lawyer: 'Cost of realtor, lawyer, buying tax and all related costs',
    realtor_cost_in_percentage_terms_pre_vat: 'Realtor cost (in percentage terms pre V.A.T)',
    cost_of_time_to_delivery_after_buying: 'Cost of time to delivery after buying',
    cost_of_vacancy_and_annual_repairs: 'Cost of vacancy and annual repairs',
    realtor_cost: 'Realtor cost (including VAT)',
    purchase_cost: 'Purchase Cost',
    additional_buy_cost: 'Additional Buying Cost',
    sales_cost: 'Sales Cost',
    additional_sell_cost: 'Additional Selling Cost',
    related_costs: 'Related costs (lawyer, apraiser etc.)',
    additional_costs_lawyer_apraiser: 'Additional costs (lawyer, apraiser etc.)',
    additional_cost: 'Additional Cost',
    additional_purchase_cost_for: 'Additional Purchase Cost for',
    additional_costs_for_making_the_apartment_ready_for_rent_paper_apartment:
      'Additional costs for making the apartment ready for rent',
    city: 'City',
    drive_folder_not_created: 'A drive folder for this client has not yet been created. Tap here to create one',
    initial_account_balance: 'Initial Account Balance',
    update_reinvestment: 'Update Reinvestment',
    update_strategy_name: 'Update Strategy Name',
    update_cashflow_change: 'Update Cashflow Change',
    group_update: 'Group Update',
    update_variable: 'Update Variable',
    update_admin: 'Update Admin',
    update_taxbrackets: 'Update Tax Bracket',
    update_customer: 'Update Customer',
    resort_to_default: 'Resort to default',
    update_notes: 'Update Notes',
    reapply_comp: 'Reapply Comp',
    update_preset: 'Update Preset',
    updating_preset: 'Updating Preset',
    update: 'Update',
    updating_armageddon_scenario: 'Updating Armageddon Scenario',
    update_strategy_start_time: 'Update Strategy Start Time',
    updating_cashflow_changes: 'Updating cashflow changes',
    to: 'To',
    past: 'Past',
    symbol: 'Symbol',
    old_password: 'Old Password',
    new_password: 'New Password',
    password: 'Password',
    action_summary: 'Action Summary',
    loan_summary: 'Loan Summary',
    one_off_event_summary: 'One Off Event Summary',
    end_with_asset: 'End with asset',
    end_with_maturity: 'End with maturity',
    end: 'End',
    stock_type: 'Stock Type',
    program_type: 'Program Type',
    type_of_interest: 'Interest Type',
    interest_type: 'Interest Type',
    transfer_type: 'Transfer Type',
    loan_type: 'Loan Type',
    apartment_type: 'Apartment Type',
    type: 'Type',
    total_assets: 'Total Assets',
    total_liabilities: 'Total Liabilities',
    total_income: 'Total Income',
    total_expenditure: 'Total Expenditure',
    total: 'Total',
    rearrange_strategies: 'Rearrange Strategies',
    close: 'Close',
    clear: 'Clear',
    shown_to_customer: 'Shown To Customer',
    ignored_assets: 'Ignored Assets',
    related_assets: 'Related Assets',
    linked_asset: 'Linked Asset ',
    assets: 'Assets',
    asset_liquidated_on: 'Asset liquidated on <b>{date}</b>',
    asset_is_linked_ib_stock: 'This asset is the linked IB stock of the liability. So trying partial selling',
    asset: 'Asset',
    liability: 'Liability',
    all_dates: 'All dates',
    can_sell_partially: 'Can Sell Partially?',
    percentage_of_payment_delayed_to_delivery: 'Percentage of payment delayed to delivery',
    risk_management: 'Risk Management',
    manage_users: 'Manage Users',
    stocks: 'Stocks',
    net_after_excersising_and_selling_stocks: 'Net after excersising and selling stocks',
    net: 'Net',
    real_estate: 'Real Estate',
    selected: 'Selected',
    advanced: 'Advanced',
    new_variables: 'New Variables',
    variables: 'Variables',
    user_already_invited:
      'This user has already been invited once. Proceeding will update the current user id and password of the user.',
    mortgage_to_be_taken: 'Mortgage to be taken (this will depend on several options)',
    maximal_mortgage_available: 'Maximal Mortgage Available',
    mortgage: 'Mortgage',
    is_salary: 'Is Salary?',
    unarchiving_customer: 'Unarchiving customer',
    something_went_wrong_try_again: 'Something went wrong! Click Here to try again',
    margin_call: 'Margin Call',
    showing: 'Showing',
    normal_state: 'Normal State',
    detailed_mode: 'Detailed Mode',
    extreme_case: 'Extreme Case',
    depressed_state: 'Depressed State',
    mode: 'Mode',
    status: 'Status',
    updating_strategy_name: 'Updating strategy name',
    updating_video_link: 'Updating Video Link...',
    updating_variable: 'Updating Variable',
    updating_admin: 'Updating Admin',
    updating_taxbrackets: 'Updating Tax Bracket',
    updating_customer: 'Updating Customer',
    updating_notes: 'Updating Notes',
    archiving_customer: 'Archiving customer',
    vat: 'V.A.T',
    total_years: 'Total Years',
    number_floor_in_building: 'Number of floors in the building',
    user_id: 'User Id',
    secondary_phone_number: 'Secondary Phone Number',
    phone_number: 'Phone Number',
    months_to_sustain_negative: 'Months to Sustain Negative Cashflow (After Crash)',
    number_of_rooms: 'number of rooms',
    buying_tax: 'Buying Tax',
    buying_tax_for: 'Buying Tax for',
    realtor_cost_for: 'Realtor Cost for',
    renovation_cost_for: 'Renovation Cost for',
    tax_on_excersising: 'Tax on excersising (selling stocks)',
    tax_on_rent: 'Tax on rent',
    tax_calculated_automatically: 'Tax calculated automatically?',
    buying_tax_calculated_automatically: 'Buying Tax calculated automatically?',
    selling_tax_calculated_automatically: 'Selling Tax calculated automatically?',
    total_tax: 'Total Tax',
    tax_total: 'Total Tax',
    tax_amount: 'Tax Amount',
    tax_and_additional_costs: 'Tax and additional costs',
    selling_tax: 'Selling Tax',
    stock: 'STOCK',
    admins: 'Admins',
    new_admin: 'New Admin',
    sorting_by: 'Sorting By',
    partially_sold_from_asset:
      'Partially sold <b>{amount}</b> from asset <b>{assetName}</b> to meet the margin requirements.',
    partial_selling_not_possible: 'Partial Selling is not possible for this stock. Trying complete liquidation',
    selling: 'Selling',
    sell: 'Sell',
    sort_by: 'Sort By',
    fetching_admins: 'Fetching admins',
    apartment_info: 'Apartment Info',
    additional_information: 'Additional Information',
    general_information: 'General Info',
    who_is_typical_renter_for_apartment: 'Who is the typical renter for the apartment?',
    allowed_calculators: 'Allowed Calculators',
    calculators: 'Calculators',
    pinui_binui: 'Pinui Binui',
    pinui_binui_label: 'Pinui Binui',
    irr_calculator: 'IRR Calculator',
    target_price_calculator: 'Target Price Calculator',
    paper_apartment: 'Paper apartment',
    paper_apartment_label: 'Paper apartment',
    rsu_options: 'RSU and Options',
    options_calculator: 'Options calculator',
    rsu_calculator: 'RSU calculator',
    group_delete_cashflow: 'Group delete cashflow',
    group_delete_only_asset: 'Group delete only Asset',
    group_delete_liability: 'Group delete liability',
    group_delete_reinvestment: 'Group delete reinvestment',
    group_delete_linked_liabilities_also: 'Group delete linked liabilities also',
    delete_only_asset: 'Delete only Asset',
    delete_linked_liabilities_also: 'Delete linked liabilities also',
    delete: 'Delete',
    wanted_price_per_sqm: 'Wanted price per SQM',
    buying_price: 'Buying Price',
    options_strike_price: 'Options strike price',
    current_stock_price: 'Current stock price (Publicly traded companies)',
    selling_price: 'Selling price',
    price_per_square_meter: 'Price per square meter',
    target_price: 'Target Price',
    stock_value_at_options_receival_date: 'Stock value at options receival date (If publicly traded company then 0)',
    do_we_need_to_pay_material_cost_index_paper_calculator: 'Do we need to pay material cost index?',
    asked_price: 'Asked Price',
    inviting_user: 'Inviting user',
    cash: 'Cash',
    adding_strategy: 'Adding strategy',
    deleting_file: 'Deleting file',
    deleting_variable: 'Deleting Variable',
    deleting_admin: 'Deleting admin',
    deleting_taxbrackets: 'Deleting Bracket',
    deleting_customer: 'Deleting customer',
    deleting_preset: 'Deleting Preset',
    deleting_strategy: 'Deleting strategy',
    new_tax_bracket: 'New Bracket',
    selling_tax_brackets_only_apartment: 'Selling Tax Brackets [Only Apartment]',
    selling_tax_brackets: 'Selling Tax Brackets',
    buying_tax_brackets_only_apartment: 'Buying Tax Brackets [Only Apartment]',
    buying_tax_brackets: 'Buying Tax Brackets',
    taxbrackets: 'Tax Brackets',
    yearly_materials_cost_index_rise_paper_calculator: 'Yearly materials cost index rise',
    yearly_materials_cost_index_rise_comp: 'Yearly materials cost index rise',
    additional_costs_for_making_the_apartment_ready_for_rent:
      'Additional costs for making the apartment ready for rent',
    stress_test: 'Stress Test',
    resetting_comp: 'Resetting comp',
    balance_sheet: 'Balance Sheet',
    expand_all: 'Expand All',
    collapse_all: 'Collapse All',
    from: 'From',
    took_from_asset: 'Took <b>{amount}</b> from asset <b>{assetName}</b>',
    took_from_linked_bank_account: 'Took <b>{amount}</b> from linked bank account <b>{accountName}</b>',
    customers: 'Customers',
    clone_customer: 'Clone Customer',
    new_customer: 'New Customer',
    asset_has_linked_loans:
      'The asset you are trying to delete has {n} loans linked to it. Do you also want to delete the loans?',
    asset_has_negative_value: 'Asset <b>{assetName}</b> has negative value on <b>{date}</b>',
    asset_has_no_money: 'Asset <b>{assetName}</b> has no value',
    meeting_video_link: 'Meeting Video Link',
    real_estate_guidance: 'Real estate guidance',
    press_alt_to_move: 'Press alt on Windows or option on Mac to move the chart around',
    logs: 'Logs',
    user_level_changed_from_to_on: 'User level changed from level {levelFrom} to {levelTo} on {date}',
    reason: 'Reason',
    no_stocks_with_linked_liabilities: 'No stocks with linked liabilities found!',
    could_not_use_asset_loan_is_greater:
      'Could not use this asset, Loan is greater than liquidated value of this asset. Liquidated Value: <b>{liquidationAmount}</b>, LOAN Value: <b>{loanAmount}</b>',
    no_strategies_created: 'No strategies created',
    no_notes_added: 'No notes added',
    no: 'No',
    address: 'Address',
    cushions: 'Cushions',
    available_level1_funds_before_crash: 'Available Level1 Funds (Before Crash)',
    available_level1_funds_after_crash: 'Available Level1 Funds (After Crash)',
    yes: 'Yes',
    stock_amount: 'Stock amount',
    options_to_cash_after_two_years: 'Options to cash (after two years of holding)',
    options_to_cash_pre_two_years: 'Options to cash (Pre two years of holding)',
    setup_mode: 'Setup Mode',
    already_have_an_account: 'Already have an account? Click here to login',
    remaining_payment: 'Remaining Payment',
    mortgage_left_at_the_end: 'Mortgage left at the end of period of holding',
    one_final_payment: 'One Final Payment',
    not_enough_assets: 'Remaining amount is <b>{amount}</b>. Not enough assets to liquidate',
    some_investment_are_not_applied:
      'Some of the investments might not have been applied because this strategy has cyclic investments. Please correct them below',
    assets_decrease: 'Assets Decrease',
    value_lost_in_months: 'Value lost in 6 months',
    depreciations: 'Depreciations',
    maximal_drawdown: 'Maximal Drawdown',
    target: 'Target',
    upload_files_to_this_apartment: 'Upload Files To This Apartment',
    loading_file: 'Loading file',
    fetching_customers: 'Fetching Customers',
    liquidation_table: 'Liquidation Table',
    opening_balance: 'Opening Balance',
    linked_bank_account: 'Linked Bank Account',
    primary_bank_account: 'Primary Bank Account',
    semi_yearly: 'Semi Yearly',
    asset_class_distribution: 'Asset Class Distribution',
    quick_search: 'Quick Search...',
    search: 'Search',
    search_users: 'Search users...',
    back_to_site: 'Back to site',
    monthly: 'Monthly',
    buying_month: 'Buying Month',
    end_month: 'End Month',
    selling_month: 'Selling Month',
    start_month: 'Start Month',
    starting_month: 'Starting Month',
    month: 'Month',
    new: 'New',
    estimated_time_for_finishing_contruction: 'Estimated time for finishing construction from demolition',
    estimated_time_for_finishing_contruction_from_demolition_months:
      'Estimated time for finishing construction from demolition in months',
    estimated_time_for_contruction: 'Estimated time for finishing construction',
    estimated_time_for_contruction_months: 'Estimated time for finishing construction in months',
    estimated_time_for_demolition: 'Estimated time for demolition',
    estimated_time_for_demolition_month: 'Estimated time for demolition in months',
    mortgage_time_to_maturity: 'Mortgage time to maturity',
    time_to_maturity: 'Time To Maturity (Months)',
    time_to_maturity_fixed_income: 'Time To Maturity (Months)',
    time_to_delivery_after_buying: 'Time to delivery after buying (months)',
    holding_period_in_years: 'Holding period in years',
    this_will_also_delete_related_investments: 'This will also delete their related investments (if any).',
    app_videos: 'App Videos',
    video_not_found_please_contact_admin: 'Video not found, Please contact the admin of the site',
    logout: 'Logout',
    start: 'Start',
    liability_ends_with: 'Liability Ends With',
    duplicate_linked_liabilities: 'This asset also has liabilities linked to it. Do you also want to duplicate them?',
    liabilities: 'Liabilities',
    sign_in_to_continue: 'Sign in to continue',
    login: 'Login',
    reinvestments: 'Reinvestments',
    cashflow_impacts: 'Cashflow Impacts',
    compare_strategies: 'Compare Strategies',
    strategies_comparison: 'Strategies Comparison',
    leave_empty_to_view_results: 'Leave empty to view recent results...',
    show_stress_test_to_client: 'Show Stress Test to Client?',
    show_all_strategies_from_customer: 'Show all strategies to customer',
    show_archived_to_client: 'Show Archived to Client?',
    show: 'Show',
    meeting_video: 'Meeting Video',
    still_insufficient_amount_for_buying: 'Materials cost indexing to be paid at construction end',
    show_explainatory_video: 'Show Explainatory Video',
    show_archived: 'Show Archived',
    difference_between_value_and_price: 'Difference between appraised value and asked price',
    apply_stress_test: 'Apply Stress Test',
    additional_comments: 'Additional comments',
    notes: 'Notes',
    upload: 'Upload',
    upload_files: 'Upload Files',
    reinvestment_and_gradual_selling: 'Reinvestment and Gradual Selling ',
    transactions: 'Transactions',
    archive: 'Archive',
    hide_zero_rows: 'Hide rows with 0 cashflow',
    hide_explainatory_video: 'Hide Explainatory Video',
    hide_all_strategies_from_customer: 'Hide all strategies from customer',
    hide: 'Hide',
    negative_amount_is: 'Negative amount is <b>{amount}</b>',
    remaining_amount_trying_asset: 'Remaining amount is <b>{amount}</b>. Trying asset <b>{assetName}</b>',
    required_amount_for_margin_is: 'Required amount for margin requirements is <b>{amount}</b>',
    asset_liquidated_from_to: 'Asset liquidated from <b>{date1}</b> to <b>{date2}</b>',
    asset_linked_asset_of_loan:
      'Current asset is linked asset of the loan. Needs to be liquidated. Liquidated Value: <b>{liquidatedValue}</b>. Remaining Loan Amount: <b>{loanValue}</b>',
    comp_table: 'Comp Table',
    user_has_not_signed_up_yet: 'User has not signed up yet',
    continue: 'Continue',

    convert_from_another_currency: 'Convert from another currency',
    convert: 'Convert',
    customer_shared: 'This customer has been shared with the following users.',
    customer_not_shared: 'This customer has not been shared with other users yet!',
    margin_loan_against: 'Margin Loan Against',
    fixed_income: 'Fixed Income',
    loan_to_asset: 'Loan To Asset',
    loan_against: 'Loan Against',
    loan: 'LOAN',
    total_income_from_rent_after_vacancy_and_tax: 'Total income from rent (after vacancy and tax)',
    total_income_from_rent: 'Total income from rent',
    income: 'Income',
    all: 'All',
    holding_postponing_tax: 'Holding and postponing the tax',
    register: 'Register',
    subtract: 'Subtract',
    transfer_applied_to: 'Transfer Applied To',
    apply: 'Apply',
    reapply: 'Reapply',
    total_monthly_payments: 'Total monthly mortgage payments',
    monthly_mortgage_payment: 'Maximal Monthly mortgage payment',
    invite_user: 'Invite User',
    the_weakest_month_and_year: 'The weakest month and year of this strategy is',
    invite: 'Invite',
    cleared_linked_loan: 'Cleared linked loan of value: <b>{clearedLoan}</b>.',
    cleared_linked_loan_remaining_cash:
      'Cleared linked loan of value: <b>{clearedLoan}</b>. Remaining cash: <b>{remainingCash}</b>',
    download: 'Download',
    expenditure: 'Expenditure',
    add_cashflow: 'Add Cashflow',
    update_cashflow: 'Update Cashflow',
    add_new_change: 'Add new change',
    add_new_cashflow_change: 'Add Cashflow Change',
    group_add: 'Group Add',
    add_value: 'Add value',
    add_new_asset: 'Add New Asset',
    add_asset: 'Add Asset',
    buy_asset: 'Buy Asset',
    group_buy_asset: 'Group Buy Asset',
    add_apartment: 'Add Appartment',
    add_new_variable: 'Add New Variable',
    add_new_admin: 'Add New Admin',
    add_new_taxbrackets: 'Add New Tax Bracket',
    add_new_customer: 'Add New Customer',
    add_new: 'Add New',
    add_liability: 'Add Liability',
    add_reinvestment: 'Add Reinvestment',
    add_new_preset: 'Add New Preset',
    add: 'Add',
    buy: 'Buy',
    equity_received: 'Equity Received',
    total_equity_for_buying: 'Total equity for buying',
    equity_for_taking_mortgage: 'Equity for taking mortgage',
    equity_to_assets: 'Equity To Assets',
    total_equity_to_put_in_the_deal: 'Total equity to put in the deal',
    equity: 'Equity',
    equity_for: 'Equity for',
    required_equity_for_excercising: 'Required equity for excercising (strike)',
    app_configuration: 'App Configuration',
    public_signup_config: 'Public signup config',
    signup_tag: 'Signup tag',
    public_signup_config_hint:
      'Each public signup config sets the permissions a customer gets when they sign up from that URL.',
    add_public_signup_config: 'Add public signup config',
    edit_public_signup_config: 'Edit public signup config',
    signup_tag_hint: 'Example: / (default), /<signup_tag>',
    end_day: 'End day',
    end_day_hint: 'Days after signup when the level changes.',
    end_day_and_level_to_together: 'End day and level to must be set together.',
    end_day_min: 'End day must be at least 1.',
    level_and_level_to_must_differ: 'Level to must be different from level.',
    signup_tag_taken: 'This signup tag is already configured.',
    signup_tag_not_valid: 'Not a valid tag: Space and / are not allowed.',
    public_signup_config_saved: 'Public signup config saved.',
    public_signup_config_deleted: 'Public signup config deleted.',
    delete_public_signup_config_confirm: 'Delete this public signup config? This action cannot be undone.',
    public_signup_config_load_error: 'This signup link is invalid.',
    public_signup_config_invalid_info: 'Please use a valid signup link.',
    no_public_signup_config: 'No public signup config yet.',
    select_level: 'Select level',
    link_copied: 'Link copied.',
    page_not_found: 'Page not found',
    preset: 'Preset',
    strategies_archived: 'The following strategies were archived!',
    is_rent: 'Is Rent?',
    is_there_an_balcony: 'Is there a balcony?',
    is_there_an_elevator: 'Is there an elevator?',
    is_there_a_safe_room: 'Is there a safe room?',
    is_there_parking: 'Is there parking? Is it legaly registered?',
    is_there_garden: 'Is there a garden?',
    is_only_apartment: 'Is Only apartment',
    is_it_the_only_apartment_buying: 'Is it the only apartment when buying',
    is_it_the_only_apartment_selling: 'Is it the only apartment when selling',
    is_apartment_properly_registered: 'Is the apartment properly registered?',
    is_there_construction_without_permit: 'is there any construction without permit?',
    is_apartment_registered_on_seller_name: "Is the apartment registered on the seller's name?",
    is_apartment_abroad: 'Is Apartment Abroad?',
    are_you_sure_you_want_to_archive_strategy: 'Are you sure you want to archive this strategy ({strategy})?',
    are_you_sure_you_want_to_unarchive_strategy: 'Are you sure you want to unarchive this strategy ({strategy})?',
    are_you_sure_you_want_to_unselect_strategy: 'Are you sure you want to unselect this strategy ({strategy})?',
    are_you_sure_you_want_to_select_strategy: 'Are you sure you want to select this strategy ({strategy})?',
    liquidation_score: 'Liquidation Score',
    rate_from_1_to_10: 'Rate from 1 to 10 (1- Terrible 10- Excellent)',
    how_easy_to_find_renters: 'How easy is it to find renters for the apartment?',
    how_well_maintained: 'How well maintained is the apartment?',
    how_good_is_location: 'How good is the location?',
    how_good_are_current_renters: 'How good are the current renters?',
    linked_apartment: 'Linked Apartment',
    apartment: 'Apartment',
    tenant_stops_paying: 'Tenant stops paying',
    charts: 'Charts',
    interest_only: 'Interest only',
    cashflow_appreciation: 'Cashflow Appreciation',
    loan_provider: 'Loan Provider',
    apartment_size: "apartment's size",
    apartment_size_after_reconstruction: 'Apartment size after reconstruction',
    loan_value: 'Loan Value',
    new_presets: 'New Presets',
    presets: 'Presets',
    highest_earner: 'Highest Earner',
    balance_with: 'Balance With',
    weakest: 'Weakest',
    yearly_materials_cost_index_rise: 'Yearly materials cost index rise',
    balloon: 'Balloon',
    home: 'Home',
    unarchiving_strategy: 'Unarchiving strategy',
    unselecting_strategy: 'Unselecting strategy',
    disable_reinvestment: 'Disable all reinvestments',
    unselect: 'Unselect',
    are_you_sure_you_want_to_delete_taxbrackets:
      'Are you sure you want to delete this Bracket? This action cannot be undone',
    linked_bank_account_has_no_money: 'Linked bank account <b>{accountName}</b> has no money',
    select_unselect_all: 'Select/Unselect All',
    select: 'Select',
    selecting_strategy: 'Selecting strategy',
    please_provide_a_primary_bank_account: 'Please provide a primary bank account for this strategy',
    are_you_sure_you_want_to_unarchive_customer:
      'Are you sure you want to unarchive the customer ({userName}) ? This action cannot be undone',
    are_you_sure_you_want_to_delete_cashflow:
      'Are you sure you want to delete this Cashflow? This action cannot be undone',
    are_you_sure_you_want_to_delete_asset: 'Are you sure you want to delete this Asset? This action cannot be undone',
    are_you_sure_you_want_to_delete_liability:
      'Are you sure you want to delete this Liability? This action cannot be undone',
    are_you_sure_you_want_to_delete_investment:
      'Are you sure you want to delete this investment option? This action cannot be undone',
    are_you_sure_you_want_to_delete_one_off_event:
      'Are you sure you want to delete this One Off Event? This action cannot be undone',
    are_you_sure_you_want_to_archive_customer:
      'Are you sure you want to archive the customer ({userName}) ? This action cannot be undone',
    are_you_sure_you_want_to_reapply:
      'Are you sure to reapply the comp table to this strategy? We recommend you make a clone of the original strategy first',
    are_you_sure_you_want_to_delete_admin:
      'Are you sure you want to delete this Admin ({admin})? This action cannot be undone',
    are_you_sure_you_want_to_delete_customer:
      'Are you sure you want to delete the customer ({userName}) ? This action cannot be undone',
    are_you_sure_delete_file:
      'Are you sure to delete this file ({fileName}). You will lose access to this file permanently?',
    are_you_sure_you_want_to_delete_variable:
      'Are you sure you want to delete this Variable? This action cannot be undone',
    are_you_sure_you_want_to_delete_preset: 'Are you sure you want to delete this Preset? This action cannot be undone',
    are_you_sure_you_want_to_delete_strategy:
      'Are you sure you want to delete this Strategy ({strategy})? This action cannot be undone',
    are_you_sure_reset_comp_table:
      'Are you sure you want to reset the Comp Table to default? This action cannot be undone!',
    confirm_password: 'Confirm Password',
    show_password: 'Show password',
    hide_password: 'Hide password',
    strategy_archive: 'Strategy ARCHIVE',
    archived: 'Archived',
    reset_to_default: 'Reset To Default',
    strategies: 'Strategies',
    new_strategy: 'New Strategy',
    strategy: 'Strategy',
    anona: 'Anona',
    please_provide_a_primary_bank_account_for_this_strategy: 'Please provide a primary bank account for this strategy',
    alphabetically: 'Alphabetically',
    real_estate_full_service: 'Real estate full service',
    reset_zoom: 'Reset Zoom',
    no_name: 'No name',
    no_files_to_show: 'No files to show!',
    no_asset: 'No Asset',
    margin_not_met: 'Margin for {stockType} loan <b>{loanName}</b> has not been met on <b>{date}</b>',
    nothing_to_show: 'Nothing to show!',
    nothing_to_show_type_to_search: 'Nothing to show. Type in the search box to view options.',
    no_matching_options_found: 'No matching options found!',
    search_options_here: 'Search options here',
    all_options_selected: 'All options selected',
    n_options_selected: '{count} options selected',
    newest_first: 'Newest first',
    oldest_first: 'Oldest first',
    no_incomes: 'No Incomes',
    no_expenditure: 'No Expenditures',
    no_email: 'No email',
    recipient_emails: 'Recipient Emails',
    secondary_email: 'Secondary Email',
    email: 'Email',
    other: 'Other',
    mortgage_percentage: 'Mortgage percentage',
    percentage: 'Percentage',
    problems_detected: 'Problems Detected',
    appraised_value: 'Appraised Value',
    crash_percentage: 'Crash Percentage',
    loses_place_of_work: 'Loses a place of work',
    showing_n_items: '{n} items',
    logging_in: 'Logging In',
    creating_account: 'Creating account',
    please_wait: 'Please wait...',
    value_in_currency: 'Value in {currency}',
    welcome_to_ETICA_crm: 'Hello! Welcome to Ethica CRM',
    contacts: 'Contacts',
    how_to_use_app: 'How to use App?',
    comments: 'Comments',
    contracts: 'Contracts',
    inbounds: 'Inbounds',
    emails: 'Emails',
    phone_calls: 'Phone Calls',
    no_comments_to_show: 'No comments to show!',
    no_contracts_to_show: 'No contracts to show!',
    type_your_comment_here: 'Type your comment here...',
    reset: 'Reset',
    are_you_sure_delete_comment: 'Are you sure you want to delete this comment? This action cannot be undone',
    admin: 'Admin',
    products: 'Products',
    add_new_product: 'Add New Product',
    update_product: 'Update Product',
    price: 'Price',
    template_link: 'Template Link on Prospero',
    are_you_sure_you_want_to_delete_products:
      'Are you sure you want to delete the product ({productName}) ? This action cannot be undone',
    send_new_contract: 'Send New Contract',
    edit_and_send_contract: 'Edit & Send',
    send: 'Send',
    quote: 'Quote',
    anona_monthly_payment: 'Anona Monthly Payment',
    copy_apartment: 'Copy Apartment',
    inviting_user: 'Inviting User',
    copy: 'Copy',
    select_customer_to_copy_apartment: 'Select Customer to copy this apartment to',
    select_customer: 'Select Customer',
    view_as_client: 'View as Client',
    interested_in_my_course: 'Interested In My Course',
    please_fill_the_form_to_continue: 'Please fill the form to continue',
    creating_user: 'Creating User',
    first_name: 'First Name',
    last_name: 'Last Name',
    user_id_get_started: 'User ID (automatically filled, will be used to sign in again)',
    password_get_started: 'Choose password',
    user_id_with_info: 'User Id',
    undo: 'Undo',
    redo: 'Redo',
    are_you_sure_archive: 'Are you sure you want to archive?',
    whatsapp: 'WhatsApp',
    example_user: 'Example User',
    example_open: 'Example',
    customer_not_found: 'Customer Not Found',
    info_about_the_neighborhood: 'Info about the neighborhood',
    transportation: 'Transportation',
    parking: 'Parking',
    physical_condition: 'Physical Condition',
    dangerous_building: 'Dangerous building?',
    number_of_air_directions: 'Number of air directions',
    developer_company: 'Developer Company',
    developer_website: 'Developer Website',
    signature_percentage: 'Signature percentage',
    show_liqudation_table_to_client: 'Show liquidation table to client?',
    show_extreme_case_to_client: 'Show Extreme case to client?',
    show_cashflow_impact_to_client: 'Show Cashflow impact to client?',
    show_cushion_to_client: 'Show Cushion to client?',
    import: 'Import',
    need_help_email_us: 'Need help? Email Us',
    update_strategy_time: 'Update Strategy Time',
    updating_strategy_time: 'Updating strategy time',
    email_get_started: 'Email (Will be used to sign in again)',
    create_password_title: 'Create Password',
    create_password_subtitle: 'You will be redirected to the login page afterwards',
    hello: 'Hello!',
    submit: 'Submit',
    Send_Password_Reset_Link: 'Send Password Reset Link',
    sending: 'Sending...',
    salesperson: 'Sales person',
    financial_strategist: 'Financial Strategist',
    real_estate_analyst: 'Real Estate Analyst',
    crm_details: 'CRM Details',
    this_customer_is_linked: 'This Customer is linked with the following CRM contact',
    matching_contact_found:
      'A matching contact has been found in CRM. The customer will be linked to the following contact.',
    rent_increase: 'Rent Increase Yearly',
    break_down: 'Breakdown',
    tax_on_cashflow: 'Tax on Cashflow',
    phone: 'Phone',
    estimated_time_for_finishing_contruction_from_demolition:
      'Estimated time for finishing construction from demolition',
    deposits: 'Deposits',
    partial_sales: 'Partial Sales',
    general: 'General',
    apartments: 'Apartments',
    drive: 'Drive',
    close_drive: 'Close drive folder',
    open_drive: 'Open drive folder',
    click_to_create_folder: 'Click here to create a folder',
    creating_drive_folder: 'Creating drive folder...',
    are_you_sure_to_delete_this_file: 'Are you sure you want to delete this file?',
    profile: 'Profiles',
    are_you_sure_you_want_to_delete_apartment_profile: 'Are you sure you want to delete this apartment profile?',
    lock_profile_edit: 'Lock Profile Edit',
    unlock_profile_edit: 'Unlock Profile Edit',
    are_you_sure_you_want_to_lock_profile_edit:
      'Are you sure you want to lock this profile? Clients will not be able to edit it.',
    are_you_sure_you_want_to_unlock_profile_edit:
      'Are you sure you want to unlock this profile? Clients will be able to edit it.',
    grant_month: 'Grant Month',
    grant_year: 'Grant Year',
    vesting_month: 'Vesting Month',
    vesting_year: 'Vesting Year',
    stock_value: 'Stock Value',
    initial_stock_value: 'Initial Stock Value',
    marginal_tax: 'Marginal Tax',
    apartment_budget: 'Apartment budget',
    time_for_finishing_construction: 'Time for finishing construction',
    holding_time: 'Holding time (including construction period)',
    willingness_for_developer_loan: 'Willingness for developer loan',
    willingness_for_linear_payment: 'Willingness for linear payment',
    developer_has_to_be_a_big_company: 'Developer has to be a big company',
    buying_decision_has_to_be_done_fast: 'Buying decision has to be done fast',
    How_much_cash_available_for_deal: 'How much cash available for deal?',
    willingness_for_early_stage_deals: 'Willingness for early stage deals',
    willingness_to_buy_apartment_with_large_scale_renovation:
      'Willingness to buy apartment with large scale renovation',
    willingness_to_buy_floor_3_or_higher_without_elevator: 'Willingness to buy floor 3 or higher without elevator',
    willingness_to_buy_complicated_deals: 'Willingness to buy complicated deals',
    willingess_to_buy_small_apartment: 'Willingness to buy small apartment (50 sqm or less)',
    holding_period: 'Holding period',
    required_cash_for_deal: 'Cash Required for Deal',
    developer_loan: 'Developer loan',
    linear_payment: 'Linear payment',
    developer_company_scale: 'Developer company scale',
    buying_decision_scale: 'Buying decision scale',
    large_scale_renovation: 'Large scale renovation',
    early_stage_deals: 'Early stage deal',
    has_3_floor_or_higher_without_elevator: 'Has 3 or higher floor without elevator',
    complicated_deals: 'Complicated deal',
    months: 'Months',
    years: 'Years',
    profile_fields: 'Profile fields',
    transfer_from: 'Transfer from',
    set_ceiling_on: 'Set ceiling on',
    set_floor_on: 'Set floor on',
    transfer_to: 'Transfer to',
    continue_after_sell: 'Continue After Sell?',
    after_tax: 'After Tax?',
    adjust_to_inflation: 'Adjust To Inflation',
    reset_password: 'Password reset',
    token_expired_invalid: 'This reset link is invalid or has expired',
    token_expired_info: 'Please request a new link to reset your password.',
    go_to_login_page: 'Click Here to Go to Login Page',
    show_rujum: 'Show Rujum',
    rujum: 'Rujum',
    resend_password_link: 'Resend password reset email',
    resend_reset_link_modal_hint:
      'Enter the email for your Ethica account. If it matches our records, we will email you a new reset link.',
    resend_reset_link_error: 'Something went wrong. Please try again.',
    field_required: 'This field is required',
    material_cost_index: 'Material cost index',
    add_customer_profile: 'Add Customer profile',
    edit_customer_profile: 'Edit customer profile',
    how_to_fill_out_a_property_profile: 'How to Fill Out a Property Profile',
    customer_profile: 'Customer Profile',
    city_relevant_to_search: 'City Relevant To Search',
    others: 'Others',
    board_name: 'Board name',
    update_one_off_event: 'Update One Off Event',
    add_one_off_event: 'Add One Off Event',
    new_one_time_event: '+ New one-time event',
    search_by_event_name: 'Search by event name',
    action_type: 'Action type',
    asset_or_liability: 'Asset or liability',
    update_asset: 'Update Asset',
    assey: 'Asset',
    add: 'Add',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    created_this_user_on: 'created this user on ',
    profile_approved_cannot_updated: 'Profile is approved by administration and cannot be updated',
    profile_not_submitted_for_approval:
      'This profile has not been submitted for approval yet. All actions are disabled.',
    created_by_customer: 'Created By Customer',
    approve: 'Approve',
    made_following_changes_on: 'made the following changes on ',
    new_apartment: 'New apartment',
    gush_helka_tat_helka: 'Gush helka tat helka',
    created_at: 'Created at',
    update_apartment: 'Update apartment',
    viewing_matching_customers: 'View matching customers',
    gush_tat_helka: 'Gush tat helka',
    related_customers: 'Related Customers',
    no_matching_customer_found: 'No matching customer found',
    customers_matching_this_apartment: 'Customers matching this apartment',
    open_google_drive: 'Open google drive',
    drop_your_files_here: 'Drop your files here',
    autofill_remaining_payment: 'Autofill Remaining Payment ({remainingPayment})',
    willingness_for_mixed_population: 'Willingness for mixed population',
    change_asset_name_confirm:
      'Are you sure you want to change the asset name? This will unlink the asset from other strategies',
    private_company: 'Private Company',
    public_company: 'Public Company',
    company_type: 'Company Type',
    change_liability_name_confirm:
      'Are you sure you want to change the liability name? This will unlink the liability from other strategies',
    lawyer: 'Lawyer',
    mortgage_broker: 'Mortgage Advisor',
    template_name: 'Template Name',
    template_body: 'Template Body',
    sandbox: 'Sandbox',
    sandbox_mode: 'Sandbox Mode',
    new_sandbox: 'New Sandbox',
    no_strategy_selected: 'No strategy selected. Please select/add a strategy to view',
    sandboxes: 'Sandboxes',
    differences: 'Differences',
    show_sandbox_strategies: 'Show Sandbox Strategies',
    select_parent_strategy: 'Select Parent Strategy',
    add_strategy_to_compare: 'Add Strategy to Compare',
    nothing_to_show_compare_strategy: 'Nothing to show yet, please select atleast 2 strategies to compare!',
    deleted: 'Deleted',
    added: 'Added',
    updated: 'Updated',
    show_differences: 'Show Differences',
    main: 'Main',
    buyer: 'Buyer',
    click_to_unmark_as_buyer: 'Click to unmark as buyer',
    click_to_unmark_as_buyer: 'Click to unmark as buyer',
    click_to_mark_as_buyer: 'Click to mark as buyer',
    confirm_unmark_buyer: 'Are you sure you want to unmark this buyer?',
    confirm_mark_buyer: 'Are you sure you want to mark this customer as a buyer?',
    available: 'Available',
    bought_by_our_client: 'Bought By Our Client',
    bought_by_outsider: 'Bought By Outsider',
    hot: 'Hot',
    move_to_sandbox: 'Move To Sandbox',
    move_to_mainbox: 'Move To Mainbox',
    strategy_transfer: 'Strategy Transfer',
    are_you_sure_to_move_this_strategy_to_mainbox: 'Are you sure you want to move this strategy to the main box?',
    are_you_sure_to_move_this_strategy_to_sandbox: 'Are you sure you want to move this strategy to the sandbox?',
    move: 'Move',
    strategy_name_exists: 'A strategy with this name already exists in the target box. Please enter a new name.',
    enter_new_strategy_name: 'Enter a new strategy name',
    generate_report: 'Generate Report',
    generate: 'Generate',
    generating_report: 'Generating report...',
    view_report: 'View Report',
    apartment_report: 'Apartment Report',
    select_report_template: 'Select Report Template',
    saving: 'Saving...',
    regenerate_report: 'Regenerate Report',
    confirm_regenerate_report:
      'Are you sure you want to regenerate the report? This will overwrite the existing report.',
    regenerate_report_progress: 'Regenerating report...',
    updating: 'Updating...',
    start_new_meeting: 'Start a New Meeting',
    confirm_start_new_meeting: 'Are you sure you want to start a new meeting?',
    start_meeting: 'Start Meeting',
    starting_meeting: 'Starting meeting...',
    join_meeting: 'Join Meeting',
    delete_report_alert: 'Are you sure you want to delete this report? This action cannot be undone.',
    deleting: 'Deleting...',
    report: 'Report',
    assigned_to: 'Assigned To',
    hide_sidebar: 'Hide Sidebar',
    show_sidebar: 'Show Sidebar',
    report_is_in_draft_mode: 'Publish report to share',
    publish_report_alert: 'Are you sure you want to publish this report? This will disable the edit mode.',
    unpublish_report_alert:
      'Are you sure you want to revert this report to draft mode? This will enable the edit mode.',
    publish: 'Publish',
    mark_as_draft: 'Mark as Draft',
    uneditable_report: 'The report is not editable. Mark as draft to edit.',
    published: 'Published',
    draft: 'Draft',
    edit_variable: 'Edit Variable',
    insert: 'Insert',
    regenerate: 'Regenerate',
    regenerated_value: 'Regenerated Value',
    update_prompt_to_generate_new_value: 'Update prompt to generate new value',
    current_value: 'Current Value',
    prompt: 'Prompt',
    document_variables: 'Document Variables',
    search_variables: 'Search Variables...',
    no_variables_found: 'No variables found',
    cancel: 'Cancel',
    send_invitation_to_customer: 'Send Invitation to Customer',
    fill_placeholder: 'Fill Placeholder',
    app_configs: 'App Configs',
    save_and_close: 'Save & Close',
    save_and_publish_for_review: 'Save & Request Approval',
    publish_for_review: 'Request Approval',
    edit_category_name: 'Edit Category Name',
    enter_category_name: 'Enter Category Name',
    calc_category: 'Category',
    shared_ownership: 'Shared Ownership',
    dangerous_building: 'Dangerous Building',
    heirs_apartment: "Heirs' Apartment",
    receivership: 'Receivership',
    irrelevant: 'Irrelevant',
    max_negative_cash_flow: 'Maximum Negative Cash Flow',
    prompt_context: 'Apartment Report Prompt Context',
    additional_prompt_context: 'Additional Prompt Context',
    system_prompt_context: 'System Prompt Context',
    edit_prompt_context: 'Edit Prompt Context',
    report_updated_successfully: 'Report updated successfully',
    error_updating_report: 'Error updating report',
    in_active_search: 'In Active Search',
    on_hold: 'On Hold',
    linked_apartment: 'Linked Apartment',
    please_select_matching_profiles: 'Please select matching profile(s)',
    relative: 'Relative',
    relative_down: 'Relative Down',
    no_matching_profiles: 'No matching profiles found for this customer',
    add_additional_field_info: 'Add Additional Field Info',
    edit_additional_field_info: 'Edit Additional Field Info',
    info: 'Info',
    clear_notes: 'Clear Note',
    add_note: 'Add Note',
    add_your_notes_here: 'Add your notes here...',
    terminal_value: 'Terminal Value',
    bought_date: 'Bought Date',
    assignment_date: 'Assignment Date',
    need_help_talk_to_us: 'Need Help? Talk to us!',
    email_us: 'Email Us',
    whatsapp_us: 'WhatsApp Us',
    in_progress: 'In Progress',
    bought_by_our_client_new: 'Bought By Our Client',
    are_you_sure_you_want_to_change_the_status_of_this_apartment:
      'Are you sure you want to change the status of this apartment?',
    field_name: 'Field Name',
    edit_multiple_apartment_field: 'Edit Multiple Apartments',
    project_stage: 'Project Stage',
    declaration_of_an_urban_renewal_complex: 'Declaration of an Urban Renewal Complex',
    election_of_tenant_representatives: 'Election of Tenant Representatives',
    choosing_a_tenant_attorney_to_conduct_a_developer_tender:
      'Choosing a Tenant Attorney to Conduct a Developer Tender',
    choosing_an_entrepreneur: 'Choosing an Entrepreneur',
    formulation_of_a_renewal_agreement: 'Formulation of a Renewal Agreement',
    examining_planning_alternatives_in_the_local_committee: 'Examining Planning Alternatives in the Local Committee',
    receiving_the_local_committees_recommendation: "Receiving the Local Committee's Recommendation",
    majority_required_67_percent: 'Majority Required 67%',
    submitting_a_city_building_plan_taba_to_a_district_committee:
      'Submitting a City Building Plan (TABA) to a District Committee',
    depositing_a_planning_application_for_objections: 'Depositing a Planning Application for Objections',
    the_urban_development_plan_takes_effect_change_in_the_urban_development_plan:
      'The Urban Development Plan Takes Effect (Change in the Urban Development Plan)',
    architectural_plan: 'Architectural Plan',
    submitting_a_permit_application_to_the_local_committee: 'Submitting a Permit Application to the Local Committee',
    permit_with_conditions_and_start_of_free_sale: 'Permit with Conditions and Start of Free Sale',
    tenant_evacuation_notice: 'Tenant Evacuation Notice',
    excavation_and_landfill_permit: 'Excavation and Landfill Permit',
    approval_to_start_work: 'Approval to Start Work',
    building_permit: 'Building Permit',
    opening_a_banking_account: 'Opening a Banking Account',
    replace: 'Replace',
    no_address: 'No Address',
    are_you_sure_you_want_to_update_this_apartment: 'Are you sure you want to update this apartment?',
    preparing_contract: 'Preparing Contract',
    email_already_in_use: 'This email is already in use.',
    related_deal: 'Related Deal',
    published: 'Published',
    deal_finished: 'Deal Finished',
    signed: 'Deal won',
    opened: 'Opened',
    declined: 'Declined',
    contract_not_needed: 'Contract not needed',
    quitted: 'Quitted',
    send_invitation_link: 'Send Invitation Link',
    client_info: 'Client Info',
    recordings: 'Recordings',
    strategist_strategies: 'Strategist Strategies',
    diy_strategies: 'DIY Strategies',
    strategy_summary: 'Strategy Summary',
    repeating_changes: 'Repeating Changes',
    one_time_events: 'One Time Events',
    graphs: 'Graphs',
    summary_of_actions: 'Summary of Actions',
    archive_client: 'Archive Client',
    unarchive_client: 'Unarchive Client',
    client_comp_table: 'Client Comp Table',
    update_group_strategies: 'Update Group Strategies',
    delete_client: 'Delete Client',
    settings: 'Settings',
    gathering_info: 'Gathering Info',
    assigned: 'Assigned',
    advanced_check: 'Advanced Check',
    preparing_contract: 'Preparing Contract',
    bought: 'Bought',
    didnt_close: "Didn't Close",
    are_you_sure_you_want_to_delete_this_group:
      'Are you sure you want to delete this group? This action cannot be undone.',
    add_group: 'Add Group',
    add_question: 'Add Question',
    title: 'Title',
    questions: 'Questions',
    question_groups: 'Question Groups',
    group_name: 'Group Name',
    footer: 'Footer',
    no_groups_created_yet: 'No groups created yet. Click "Add Group" to get started.',
    short: 'Short',
    long: 'Long',
    rsu: 'RSU',
    pension: 'Pension',
    created_by_client: 'Created by Client',
    chosen_strategy: 'Chosen Strategy',
    show_more: 'Show more...',
    show_less: 'Show less...',
    change_logs: 'Logs',
    removed: 'Removed',
    no_any_logs: 'No logs to show!',
    default_mode: 'Default Mode',
    in_percentage: 'In Percentage',
    link_a_new_liability: 'Link a new liability',
    update_liability: 'Update Liability',
    add_new_liability: 'Add New Liability',
    group_update_liability: 'Group Update Liability',
    group_add_liability: 'Group Add Liability',
    updating_liability: 'Updating Liability...',
    adding_liability: 'Adding Liability....',
    duplicate_apartment: 'Duplicate Apartment',
    duplicate_apartment_alert:
      'Are you sure you want to duplicate this apartment? This action will create a new apartment with the same details.',
    confirm_archive_apartment_text: 'Are you sure you want to archive the apartment?',
    confirm_unarchive_apartment_text: 'Are you sure you want to unarchive the apartment?',
    archiving_apartment: 'Archiving apartment...',
    unarchiving_apartment: 'Unarchiving apartment...',
    apartment_archived_success: 'Apartment archived successfully',
    apartment_unarchived_success: 'Apartment unarchived successfully',
    do_you_want_to_archive_the_apartment: 'Do you want to archive the apartment?',
    variable: 'Variable',
    do_you_want_to_unarchive_the_apartment: 'Do you want to unarchive the apartment?',
    export_csv: 'Export CSV',
    advanced_check_date: 'Advanced Check Date',
    did_not_close_date: "Didn't Close Date",
    starting_profit: 'Starting Profit',
    tax_on_profit: 'Tax on Profit',
    table_view: 'Table View',
    group_view: 'Group View',
    total_investment_made_so_far: 'Total Investment',
    appreciation_value_so_far: 'Appreciation',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
    all_users: 'All Users',
    show_archived_customers: 'Show archived customers',
    hide_archived_customers: 'Hide archived customers',
    min: 'Min',
    max: 'Max',
    select_all: 'Select All',
    n_cities_selected: '+ {count} cities selected',
    n_city_selected: '+ {count} city selected',
    no_related_deals: 'No related deals for this client',
    no_options: 'No options',
    switch_to_manual_mode: 'Switch to Manual mode',
    switch_to_auto_mode: 'Switch to Auto mode',
    expected_selling_tax: 'Expected Selling Tax',
    upto: 'Upto',
    asset_value_at_selling_month_and_year: 'Asset value at selling month and year',
    phone_numbers: 'Phone Numbers',
    select_one: 'Select one',
    select_one_ellipsis: 'Select one...',
    read_only: 'Read Only',
    trial: 'Trial',
    basic: 'Basic',
    full_access: 'Full access',
    premium: 'Premium',
    enter_questions_title: 'Enter questions title',
    enter_questions_description: 'Enter questions description',
    enter_group_name: 'Enter group name',
    enter_question_text: 'Enter question text',
    enter_footer_text: 'Enter footer text',
    edit_calculator: 'Edit Calculator',
    sort_desc: '(Desc)',
    sort_asc: '(Asc)',
    save_changes: 'Save changes',
    okay: 'Okay',
    open: 'Open',
    previous: 'Previous',
    next: 'Next',
    loading: 'Loading...',
    uploading_please_wait: 'Uploading please wait...',
    click_or_drag_and_drop_files_here: 'Click Or Drag and drop files here',
    no_files_uploaded: 'No files uploaded',
    no_preview_to_show: 'No preview to show!',
    no_data_available: 'No Data Available',
    no_strategies_to_show: 'No strategies to show!',
    no_profiles_found: 'No profiles found',
    no_customers_selected: 'No Customers Selected',
    no_any_customers_selected: 'No any customers selected',
    selected_customers: 'Selected customers',
    no_customers_to_show: 'No customers to show',
    leverage_options: 'Leverage Options',
    view_leverage_options: 'View Leverage Options',
    max_leverage_allowed: 'Max. Leverage Allowed',
    rem_leverage: 'Rem. Leverage',
    amount: 'Amount',
    shekels: 'Shekels',
    update_investments: 'Update Investments',
    update_multiple_strategies: 'Update Multiple Strategies',
    filter: 'Filter',
    empty: 'Empty',
    hebrew_name: 'Hebrew Name',
    english_name: 'English Name',
    n_actions: '{count} actions',
    n_action: '{count} action',
    tax_percent: 'Tax (%)',
    calculator: 'Calculator'
  },
  Hebrew: {
    variable: 'משתנה',
    link_a_new_liability: 'קשר התחייבות חדשה',
    update_liability: 'עדכן התחייבות',
    add_new_liability: 'הוסף התחייבות חדשה',
    group_update_liability: 'עדכן התחייבות קבוצתית',
    group_add_liability: 'הוסף התחייבות קבוצתית',
    updating_liability: 'מעדכן התחייבות...',
    adding_liability: 'מוסיף התחייבות...',
    in_percentage: 'ב %',
    change_logs: 'יומנים',
    removed: 'הוּסַר',
    send_invitation_link: 'שלח קישור הזמנה',
    payments: 'תשלומים',
    down_payment: 'תשלום ראשון (Downpayment)',
    paying_tax_investing_somewhere: 'תשלום מס והשקעה חלופית',
    paying_tax_at_period_end: 'תשלום מס בתום התקופה',
    tax: 'תשלום מס',
    pay_installment_cost: 'תשלום לקבלן',
    pay_indexing_cost: 'תשלום הצמדה למדד',
    gradual_payment: 'תשלום הדרגתי',
    pay: 'תשלום',
    target_irr: 'תשואת יעד',
    real_estate_irr: 'תשואה שנתית על הון עצמי',
    irr: 'תשואה שנתית על הון עצמי',
    irr_no_reconstruction: 'תשואה שנתית במקרה בו לא תהיה התחדשות',
    net_yearly_return_on_rent: 'תשואה פירותית נטו',
    yearly_return_from_rent: 'תשואה פירותית ברוטו',
    return_cashflow: 'תשואה פירותית',
    total_roi: 'תשואה כוללת על הון עצמי',
    return_appreciation: 'תשואה הונית',
    bad: 'תרחיש שלילי',
    current_scenario: 'תרחיש נוכחי',
    good: 'תרחיש חיובי',
    original: 'תרחיש בסיס',
    armageddon: 'תרחיש ארמגדון',
    armageddon_scenario: 'תרחיש ארמגדון',
    margin_ceiling: 'תקרת מרג’ין',
    apartment_budget: 'מחיר דירה משוער',
    time_to_delivery_after_buying: 'תקופת פינוי בחודשים (חודשים)',
    real_estate_holding_period: 'תקופת החזקה צפוייה',
    grace_period: 'תקופת גרייס (בחודשים)',
    configure: 'תצוגה',
    role: 'תפקיד',
    description: 'תיאור',
    expected_cashflow: 'תזרים צפוי',
    cashflow: 'תזרים מזומנים ',
    multi_generational: 'תוכנית בין דורית',
    strategic_planning: 'תוכנית אסטרטגית',
    frequency: 'תדירות',
    end_date_calculated_automatically: 'תאריך סיום מחושב אוטומטית?',
    start_date_calculated_automatically: 'תאריך התחלה מחושב אוטומטית?',
    end_date: 'תאריך סיום',
    date: 'תאריך',
    added_on: 'תאריך יצירה',
    start_date: 'תאריך התחלה',
    share_with_new_user: 'שתף עם משתמש חדש',
    show_general_info_to_client: 'שתף מידע כללי עם הלקוח?',
    share_strategies: 'שתף אסטרטגיות',
    share: 'שתף',
    annuity: 'שפיצר',
    yearly: 'שנתי',
    buying_year: 'שנת קנייה',
    end_year: 'שנת סיום',
    selling_year: 'שנת מכירה',
    start_year: 'שנת התחלה',
    years: 'שנים',
    configure_armageddon: 'שנה הנחות יסוד ארמגדון',
    change: 'שנה',
    year: 'שנה',
    kept_remaining_cash: 'שמרנו יתרת מזומנים <b>{amount}</b>',
    saving_cashflow_changes: 'שמירת שינויים בתזרים',
    maintain_margin: "שמירת מרג'ין",
    save: 'שמור',
    first_name: 'שם פרטי',
    secondary_name: 'שם נוסף',
    user_id_get_started: 'שם משתמש (ממולא אוטומטית, ישמש לכניסה מחדש למערכת)',
    user_id_with_info: 'שם משתמש (לא כתובת המייל שלכם, קיבלתם אותו במייל ההרשמה)',
    last_name: 'שם משפחה',
    realtor_seller_name: 'שם המתוווך\\ בעל הדירה',
    name: 'שם',
    sent_remaining_cash: 'שלחנו יתרת מזומנים <b>{amount}</b> לחשבון בנק <b>{accountName}</b>',
    welcome_to_ETICA_financials: 'שלום וברוכים הבאים לאתיקה פיננסים!',
    rent: 'שכר דירה',
    clone_strategy: 'שכפל אסטרטגיה {strategy}',
    clone: 'שכפל',
    duplicate: 'שכפל',
    mark_several_strategies: 'סמן כמה אסטרטגיות',
    strategies_marked: 'סומנו {count} אסטרטגיות',
    are_you_sure_to_move_these_strategies_to_sandbox: 'האם אתה בטוח שברצונך להעביר אסטרטגיות אלו לארגז החול?',
    are_you_sure_to_move_these_strategies_to_mainbox: 'האם אתה בטוח שברצונך להעביר אסטרטגיות אלו לתיבה הראשית?',
    rent_pre_construction: 'שכירות לפני פינוי',
    monthly_rent_post_construction: 'שכירות לאחר טופס 4',
    rent_post_construction: 'שכירות לאחר טופס 4',
    total_income_from_rent_minus_monthly_payment: 'שכירות כוללת בקיזוז החזרי משכנתה כוללים',
    total_rent: 'שכירות כוללת',
    return_cashflow_monthly: 'הכנסה חודשית צפוייה',
    monthly_rent: 'שכירות חודשית',
    rent_during_contruction: 'שכירות בזמן פינוי (ברירת מחדל: כמו בשגרה)',
    forgot_password: 'שכחת סיסמא?',
    marginal_rate_of_income: 'שיעור מס שולי',
    capital_appreciation_tax: 'שיעור מס רווחי הון',
    one_off_change: 'שינויים חד פעמיים',
    interest_rate_changes: 'שינויים בריבית',
    one_off_change_by: 'שינוי',
    heads_up: 'שים לב!',
    update_start_date_note_for_strategies: 'שים לב, החודש והשנה של כל אסטרטגיה אצל הלקוח יעודכנו',
    area_in_square_meters: 'שטח במ"ר',
    unarchive: 'שחזר',
    saving_variable: 'שומר משתנים',
    saving_admin: 'שומר מנהל',
    saving_taxbrackets: 'שומר מדרגת מס',
    saving_customer: 'שומר לקוח',
    saving_preset: 'שומר הגדות יסוד',
    archiving_strategy: 'שומר אסטרטגיה בארכיון',
    future_value_pre_tax: 'שווי עתידי לפני מס',
    net_value: 'שווי נטו',
    total_value: 'שווי כולל',
    value_of_stocks_with_marginal_tax_rate: 'שווי המניות החייבות במס שולי',
    value_of_stocks_with_capital_aprreciation_tax_rate: 'שווי המניות החייבות במס רווחי הון',
    value_of_received_apartment_today: 'שווי דירת התמורה היום',
    value_after_renovation: 'שווי אחרי שיפוץ',
    appreciation: 'שבח',
    margin_floor: 'רצפת מרג’ין',
    level: 'רמת הרשאה',
    level_to: 'רמת יעד',
    buying: 'רכישה',
    mortgage_interest: 'ריבית משכנתה',
    interest: 'ריבית ',
    loan_interest: 'ריבית ',
    profit_from_selling_brfore_tax: 'רווח ממכירה (לפני מס)',
    profit_from_selling_after_tax: 'רווח ממכירה (אחרי מס)',
    total_net_profit: 'רווח כולל נטו',
    monthly_net_profit: 'רווח נטו חודשי',
    profit_at_excersising_pre_tax: 'רווח במימוש לפני מס',
    profit: 'רווח',
    pensioni: 'פנסיה וקרנות השתלמות',
    quaterly: 'רבעוני',
    asset_name: 'קשר נכס',
    link_a_new_liability: 'קשר התחייבות חדשה',
    stock_KSH: 'קרן השתלמות',
    video_link: 'קישורי וידאו',
    total_loan_decrease: 'קיטון בחוב לאורך התקופה',
    asset_category: 'קטגוריה',
    category: 'קטגוריה',
    apartment_floor_number: 'קומת הדירה',
    files_from_drive: 'קבצים בתיקייה',
    other_files: 'קבצים אחרים',
    set_ceiling_on: 'קבע תקרה על',
    set_a_ceiling_value: 'קבע תקרה',
    set_floor_on: 'קבע רצפה ל',
    set_a_floor_value: 'קבע רצפה',
    set: 'קבע',
    get_reset_email: 'קבל מייל לשחזור סיסמא',
    fixed: 'קבועה',
    view_files: 'צפה בקבצים',
    view_profile: 'צפה בפרופיל',
    yearly_growth_rate: 'צמיחה שנתית (%)',
    balance_sheet_growth_with_time: 'צמיחה במאזן לאורך זמן',
    add_new_strategy: 'צור אסטרטגיה חדשה',
    viewing_user: 'צופה במשתמש',
    open_drive_folder: 'פתח תיקיה בדרייב',
    parameters: 'פרמטרים',
    profile_details: 'פרטי משתמש',
    difference: 'פער',
    active: 'פעיל',
    actions: 'פעולות',
    edit_mode: 'פעולה חדשה',
    buy_mode: 'מצב רכישה',
    add_mode: 'מצב הוספה',
    add_mode_tooltip:
      'שינויים לכל נכס או התחייבות לא ישפיעו על נכסים או התחייבויות אחרים (מיועד לבניית מצב קיים ולא לבניית תרחישים אפשריים)',
    buy_mode_tooltip:
      'שינויים בכל נכס או התחייבות משפיעים על המאזן הכולל (קנייה של נכס תוריד יתרה מקופה אחרת בפורטפוליו)',
    action: 'פעולה',
    filters: 'פילטרים',
    stock_portfolio: 'פורטפוליו מניות',
    end_value: 'ערך סיום',
    monthly_value: 'ערך חודשי',
    initial_value: 'ערך התחלתי',
    value: 'ערך',
    city_relevant_to_search: 'ערים רלוונטיות לחיפוש',
    edit: 'ערוך',
    rent_increase: 'עליית שכירות שנתית',
    yearly_appreciation: 'עליית ערך שנתית צפוייה',
    annual_appreciation: 'עליית ערך שנתית',
    expected_value_appreciation_from_change: 'עליית ערך צפויה בעקבות תוספות ושדרוגים (לא כולל עלות)',
    expected_appreciation: 'עליית ערך צפויה',
    value_added_by_renovation: 'עליית ערך בעקבות שיפוץ',
    do_we_need_to_pay_material_cost_index:
      'עליית ערך אזורית לא רלוונטית בצורה שונה מהותית מעליית הערך של הדירה הספציפית.',
    renovation_cost: 'עלות שיפוץ',
    total_deal_cost: 'עלות עסקה כוללת',
    cost_of_retailer_lawyer: 'עלות תיווך, עו"ד, מס רכישה וכל העלויות הנלוות',
    realtor_cost_in_percentage_terms_pre_vat: 'עלות מתווך (באחוזים לפי מע"מ)',
    cost_of_time_to_delivery_after_buying: 'עלות זמן המכירה לאחר רכישה',
    cost_of_vacancy_and_annual_repairs: 'עלות vacancy ותיקונים שנתיים',
    realtor_cost: 'עלויות תיווך',
    purchase_cost: 'עלויות נלוות לרכישה',
    additional_buy_cost: 'עלויות נלוות לרכישה',
    sales_cost: 'עלויות נלוות למכירה',
    additional_sell_cost: 'עלויות נלוות למכירה',
    related_costs: 'עלויות נלוות (עו"ד, שמאי וכו\')',
    additional_cost: 'עלויות נלוות',
    additional_purchase_cost_for: 'עלויות נלוות',
    additional_costs_for_making_the_apartment_ready_for_rent_paper_apartment: 'עלויות להכנת הדירה להשכרה',
    city: 'עיר',
    drive_folder_not_created: 'עוד לא נוצרה תיקייה בדרייב. לחץ כדי ליצור',
    initial_account_balance: 'עו"ש התחלתי',
    update_reinvestment: 'עדכן תקרות ורצפות',
    update_strategy_name: 'עדכן שם אסטרטרגיה',
    update_cashflow_change: 'עדכן שינוי בתזרים',
    group_update: 'עדכן קבוצתית',
    update_variable: 'עדכן משתנה',
    update_admin: 'עדכן מנהל',
    update_taxbrackets: 'עדכן מדרגת מס',
    update_customer: 'עדכן לקוח',
    resort_to_default: 'עדכן לברירת מחדל',
    update_notes: 'עדכן הערות',
    reapply_comp: 'עדכן הנחות יסוד',
    update_preset: 'עדכן הגדרות יסוד',
    updating_preset: 'עדכן ברירות מחדל',
    update: 'עדכן',
    updating_armageddon_scenario: 'עדכון תרחיש ארמגדון',
    update_strategy_start_time: 'עדכון תאריך התחלת אסטרטגיה',
    updating_cashflow_changes: 'עדכון שינויים בתזרים ',
    developer_has_to_be_a_big_company: 'עד כמה חשוב לך שהיזם יהיה יזם גדול ומוכר',
    willingness_to_buy_apartment_with_large_scale_renovation: 'האם אתה מוכן לקנות דירה שדורשת שיפוץ משמעותי?',
    buying_decision_has_to_be_done_fast: 'האם אתה מוכן לבצע עסקה "מעכשיו לעכשיו"',
    to: 'עד',
    past: 'עבר',
    symbol: 'סמל',
    old_password: 'סיסמא ישנה',
    new_password: 'סיסמא חדשה',
    password: 'סיסמא',
    action_summary: 'סיכום פעולות',
    loan_summary: 'סיכום הלוואות',
    one_off_event_summary: 'סיכום אירועים חד פעמיים',
    end_with_asset: 'סיים עם נכס',
    end_with_maturity: 'סיים לפי מועד פירעון',
    end: 'סיום',
    stock_type: 'סוג תיק ני"ע',
    program_type: 'סוג תוכנית',
    type_of_interest: 'סוג ריבית',
    interest_type: 'סוג ריבית',
    preset: 'סוג נכס',
    transfer_type: 'סוג העברה',
    loan_type: 'סוג הלוואה',
    apartment_type: 'סוג דירה',
    type: 'סוג',
    total_assets: 'סה”כ נכסים',
    total_liabilities: 'סה”כ התחייבויות',
    total_income: 'סה”כ הכנסה',
    total_expenditure: 'סה”כ הוצאה',
    total: 'סה"כ',
    rearrange_strategies: 'סדר אסטרטגיות מחדש ',
    close: 'סגור',
    clear: 'נקה',
    shown_to_customer: 'נראה ללקוח',
    ignored_assets: 'נכסים שלא נקנו',
    related_assets: 'נכסים קשורים',
    linked_asset: 'נכסים קשורים',
    assets: 'נכסים',
    asset_liquidated_on: 'נכס מונזל בתאריך <b>{date}</b>',
    asset_is_linked_ib_stock: "נכס זה קשור לחשבון מרג'ין. מנסה הנזלה חלקית",
    asset: 'נכס',
    liability: 'התחייבות',
    all_dates: 'כל התאריכים',
    willingness_for_linear_payment: 'נכונות לתשלום לינארי',
    willingness_for_early_stage_deals:
      'נכונות לעסקאות שנמצאות בשלבים ראשוניים של התחדשות עירונית (צפי ליותר מ- 7 שנים להריסה) ',
    can_sell_partially: 'ניתן למכור חלקית?',
    percentage_of_payment_delayed_to_delivery:
      'ניתן לחשוב על זה כעל 20% כברירת מחדל בתחילה והיתרה בקבלת טופס 4. ניתן להגדיר לשנה מסויימת לאורך הדרך תשלום מסויים וזה ירד מיתרת התשלום בטופס 4.',
    risk_management: 'ניהול סיכונים',
    manage_users: 'ניהול משתמשים',
    stocks: 'ני"ע',
    net_after_excersising_and_selling_stocks: 'נטו לאחר מימוש ומכירת מניות',
    net: 'נטו',
    real_estate: 'נדל”ן',
    selected: 'נבחר',
    advanced: 'מתקדם',
    new_variables: 'משתנים חדשים',
    variables: 'משתנים',
    user_already_invited: 'משתמש זה כבר הוזמן פעם אחת. המשך יאפס את פרטי המשתמש ויזמין אותו מחדש',
    mortgage_to_be_taken: 'משכנתה שתילקח',
    maximal_mortgage_available: 'משכנתה מקסימלית',
    mortgage: 'משכנתה',
    is_salary: 'משכורת',
    unarchiving_customer: 'משחזר לקוח',
    something_went_wrong_try_again: 'משהו השתבש, לחץ כאן כדי לנסות שוב',
    margin_call: "מרג'ין קול",
    showing: 'מציג',
    normal_state: 'מצב רגיל',
    detailed_mode: 'מצב פיתוח',
    extreme_case: 'מצב משבר פיננסי',
    depressed_state: 'מצב משבר פיננסי',
    mode: 'מצב',
    status: 'מצב',
    updating_strategy_name: 'מעדכן שם אסטרטגיה',
    updating_video_link: 'מעדכן קישורי וידאו',
    updating_variable: 'מעדכן משתנים',
    updating_admin: 'מעדכן מנהל',
    updating_taxbrackets: 'מעדכן מדרגת מס',
    updating_customer: 'מעדכן לקוח',
    updating_notes: 'מעדכן הערות',
    archiving_customer: 'מעביר לארכיון',
    vat: 'מע"מ',
    total_years: 'מספר שנים',
    number_floor_in_building: 'מספר קומות בבניין',
    user_id: 'מספר משתמש',
    secondary_phone_number: 'מספר טלפון נוסף',
    phone_number: 'מספר טלפון',
    months_to_sustain_negative: 'מספר חודשים בהם ניתן לשאת בתזרים שלילי מההון (אחרי משבר)',
    number_of_rooms: 'מספר חדרים',
    buying_tax: 'מס רכישה',
    buying_tax_for: 'מס רכישה',
    tax_on_excersising: 'מס על מימוש (מכירת מניות)',
    tax_on_rent: 'מס על ההכנסה',
    tax_on_cashflow: 'מס על ההכנסה(%)',
    tax_calculated_automatically: 'מס מחושב אוטומטית?',
    total_tax: 'מס כולל',
    tax_total: 'סה"כ מס',
    tax_amount: 'מס כולל',
    tax_and_additional_costs: 'מס ועלויות נוספות',
    selling_tax: 'מס במכירה',
    stock: 'מניה',
    admins: 'מנהלים',
    new_admin: 'מנהל חדש',
    sorting_by: 'ממיין לפי',
    partially_sold_from_asset: "מכרנו חלקית <b>{amount}</b> מתוך נכס <b>{assetName}</b> כדי לעמוד בדרישות המרג'ין",
    partial_selling_not_possible: 'מכירה חלקית לא אפשרית לנכס זה. מנסה מכירה מלאה',
    selling: 'מכירה',
    sell: 'מכירה',
    sort_by: 'מיין לפי',
    fetching_admins: 'מייבא מנהלים',
    apartment_info: 'מידע על הדירה',
    additional_information: 'מידע נוסף',
    general_information: 'מידע כללי',
    who_is_typical_renter_for_apartment: 'מי השוכר הקלאסי לנכס? סטודנטים וזוגות צעירים\\ משפחות ומבוגרים\\ תיירים',
    allowed_calculators: 'מחשבונים זמינים',
    calculators: 'מחשבונים',
    pinui_binui: 'מחשבון פינוי בינוי',
    pinui_binui_label: 'דירה יד 2',
    irr_calculator: 'מחשבון מחיר יעד',
    target_price_calculator: 'מחשבון מחיר יעד',
    paper_apartment: 'מחשבון דירה על הנייר',
    paper_apartment_label: 'דירה מקבלן',
    rsu_options: 'מחשבון אופציות ו- RSU',
    options_calculator: 'מחשבון אופציות',
    rsu_calculator: 'מחשבון RSU',
    group_delete_cashflow: 'מחק קבוצתית תזרים מזומנים',
    group_delete_only_asset: 'מחק קבוצתית נכס בלבד',
    group_delete_liability: 'מחק קבוצתית התחייבות',
    group_delete_reinvestment: 'מחק קבוצתית השקעה מחדש, רצפות ותקרות',
    group_delete_linked_liabilities_also: 'מחק קבוצתית גם התחייבויות',
    delete_only_asset: 'מחק נכס בלבד',
    delete_linked_liabilities_also: 'מחק גם התחייבויות',
    delete: 'מחק',
    wanted_price_per_sqm: 'מחיר רצוי למטר רבוע',
    buying_price: 'מחיר רכישה',
    options_strike_price: 'מחיר סטרייק של האופציות',
    current_stock_price: 'מחיר מנייה נוכחי (חברות ציבוריות)',
    selling_price: 'מחיר מכירה',
    price_per_square_meter: 'מחיר למ"ר',
    target_price: 'מחיר יעד',
    stock_value_at_options_receival_date: 'מחיר המנייה במועד מתן האופציות (חברות פרטיות- 0)',
    do_we_need_to_pay_material_cost_index_paper_calculator: 'מחיר הדירה צמוד למדד?',
    asked_price: 'מחיר ביקוש',
    inviting_user: 'מזמין משתמש',
    cash: 'מזומן',
    adding_strategy: 'מוסיף אסטרטגיה',
    deleting_file: 'מוחק קובץ',
    deleting_variable: 'מוחק משתנה',
    deleting_admin: 'מוחק מנהל',
    deleting_taxbrackets: 'מוחק מדרגת מס',
    deleting_customer: 'מוחק לקוח',
    deleting_preset: 'מוחק ברירת מחדל',
    deleting_strategy: 'מוחק אסטרטגיה',
    new_tax_bracket: 'מדרגת מס חדשה',
    selling_tax_brackets_only_apartment: 'מדרגות מס שבח [דירה יחידה]',
    selling_tax_brackets: 'מדרגות מס שבח',
    buying_tax_brackets_only_apartment: 'מדרגות מס רכישה [דירה יחידה]',
    buying_tax_brackets: 'מדרגות מס רכישה',
    taxbrackets: 'מדרגות מס',
    yearly_materials_cost_index_rise_paper_calculator: 'מדד תשומות הבנייה שנתי',
    yearly_materials_cost_index_rise_comp: 'מדד תשומות הבנייה',
    material_cost_index: 'מדד תשומות הבנייה',
    additional_costs_for_making_the_apartment_ready_for_rent:
      'מדד התשומות יחושב רק על החלק שלא שולם עדיין ובאחוזים משווי הרכישה כלומר 40% מתוך החוב יוצמד והיתרה לא. כאשר חלק משולם הוא משולם בצורה שווה משני הרכיבים. אפשר להזין פשוט מדד נמוך יותר.',
    stress_test: 'מבחן לחץ',
    resetting_comp: 'מאפס טבלת הגדרות יסוד',
    balance_sheet: 'מאזן',
    expand_all: 'הרחב הכול',
    collapse_all: 'כווץ הכול',
    apartments: 'מאגר דירות',
    from: 'מ',
    took_from_asset: 'לקחנו <b>{amount}</b> מחשבון בנק <b>{assetName}</b>',
    took_from_linked_bank_account: 'לקחנו <b>{amount}</b> מחשבון בנק <b>{accountName}</b>',
    customers: 'לקוחות',
    clone_customer: 'לקוח משוכפל',
    new_customer: 'לקוח חדש',
    asset_has_linked_loans: 'לנכס שאתה מנסה למחוק יש {n} התחייבויות קשורות. אתה רוצה למחוק גם את ההתחייבויות?',
    asset_has_negative_value: 'לנכס <b>{assetName}</b> יתרה שלילית בתאריך <b>{date}</b>',
    asset_has_no_money: 'לנכס <b>{assetName}</b> אין שווי',
    meeting_video_link: 'לינק הקלטת פגישה',
    real_estate_guidance: 'ליווי נדל”ן',
    press_alt_to_move: 'לחץ על ALT בווינדוס או על Option בMac כדי להזיז את התרשים',
    how_to_use_app: 'לחץ לצפייה בסרטון הסבר',
    logs: 'לוגים',
    user_level_changed_from_to_on: 'רמת המשתמש השתנתה מ-{levelFrom} ל-{levelTo} בתאריך {date}',
    reason: 'סיבה',
    no_stocks_with_linked_liabilities: 'לא נמצאו ני"ע עם התחייבויות מקושרות',
    could_not_use_asset_loan_is_greater:
      'לא ניתן להשתמש בנכס זה. יתרת הלוואה גדולה משווי נכס <b>{liquidationAmount}</b>, LOAN Value: <b>{loanAmount}</b>',
    no_strategies_created: 'לא נוצרו אסטרטגיות',
    no_notes_added: 'לא נוספו הערות',
    no: 'לא ',
    address: 'כתובת',
    cushions: 'כריות',
    available_level1_funds_before_crash: 'כספים נזילים מדרגה 1 (לפני משבר)',
    available_level1_funds_after_crash: 'כספים נזילים מדרגה 1 (אחרי משבר)',
    yes: 'כן',
    stock_amount: 'כמות מניות',
    options_to_cash_after_two_years: 'כדאיות מימוש אופציות למזומן (כאשר עברו שנתיים מקבלת האופציות)',
    options_to_cash_pre_two_years: 'כדאיות מימוש אופציות למזומן (כאשר *לא* עברו שנתיים מקבלת האופציות)',
    setup_mode: 'כבר קיים',
    already_have_an_account: 'כבר יש לך חשבון? לחץ כאן להתחבר',
    remaining_payment: 'יתרת תשלום',
    mortgage_left_at_the_end: 'יתרת משכנתה בתום התקופה',
    one_final_payment: 'יתרה בטופס 4',
    not_enough_assets: 'יתרה <b>{amount}</b> אין מספיק נכסים להנזיל',
    some_investment_are_not_applied: 'יתכן שחלק מההשקעות לא יושמו בגלל היגיון מעגלי. אנא בדוק סגירות',
    willingness_for_developer_loan: 'יש ללקוח נכונות לקבל הלוואת קבלן',
    assets_decrease: 'ירידת ערך נכסים',
    value_lost_in_months: 'ירידת ערך ב6 חודשים',
    depreciations: 'ירידות ערך',
    maximal_drawdown: 'ירידה מקסימלית',
    target: 'יעד',
    upload_files_to_this_apartment: 'טען קבצים לדירה זו',
    loading_file: 'טוען קבצים',
    fetching_customers: 'טוען לקוחות',
    liquidation_table: 'טבלת הנזלה',
    opening_balance: 'חשבון פתיחה',
    linked_bank_account: 'חשבון משויך',
    primary_bank_account: 'חשבון בנק ראשי',
    semi_yearly: 'חצי- שנתי',
    asset_class_distribution: 'חלוקה בסוגי נכסים',
    quick_search: 'חיפוש מהיר',
    search: 'חיפוש',
    search_users: 'חיפוש משתמשים...',
    back_to_site: 'חזרה לאתר',
    months: 'חודשים',
    monthly: 'חודשי',
    buying_month: 'חודש קנייה',
    end_month: 'חודש סיום',
    selling_month: 'חודש מכירה',
    start_month: 'חודש התחלה',
    starting_month: 'חודש התחלה',
    month: 'חודש',
    new: 'חדש',
    estimated_time_for_finishing_contruction: 'זמן משוער לסיום הבנייה ממועד ההריסה (בשנים)',
    estimated_time_for_contruction_months: 'זמן משוער לסיום בנייה (בחודשים)',
    estimated_time_for_contruction: 'זמן משוער לסיום בנייה',
    estimated_time_for_demolition: 'זמן משוער להריסת מבנה קיים',
    mortgage_time_to_maturity: 'זמן לפרעון',
    time_to_maturity_fixed_income: 'זמן לפרעון (חודשים)',
    time_to_maturity: 'תקופה עד הפירעון (בחודשים)',
    monthly_payment: 'תשלום חודשי',
    time_for_finishing_construction: 'זמן למסירה',
    holding_period_in_years: 'זמן החזקה בשנים',
    holding_time: 'זמן החזקה (כולל תקופת בנייה) ',
    estimated_time_for_finishing_contruction_from_demolition: 'זמן בנייה משוער',
    this_will_also_delete_related_investments: 'זה ימחק גם את ההשקעות מחדש\\ רצפות\\ תקרות המקושרות',
    app_videos: 'וידאויים',
    video_not_found_please_contact_admin: 'וידאו לא נמצא',
    logout: 'התנתק',
    start: 'התחלה',
    liability_ends_with: 'התחייבות מסתיימת עם',
    duplicate_linked_liabilities: 'התחייבויות מקושרות לנכס הזה, האם תרצה לשכפל אותן?',
    liabilities: 'התחייבויות',
    sign_in_to_continue: 'התחבר כדי להמשיך',
    login: 'התחבר',
    adjust_to_inflation: 'התאמה לאינפלציה',
    reinvestments: 'השקעה מחדש',
    cashflow_impacts: 'השפעה על תזרים',
    compare_strategies: 'השוואת אסטרטגיות',
    strategies_comparison: 'השוואת אסטרטגיות',
    leave_empty_to_view_results: 'השאר ריק לראות תוצאות אחרונות',
    show_stress_test_to_client: 'הראה מבחן לחץ ללקוח',
    show_all_strategies_from_customer: 'הראה את כל האסטרטגיות ללקוח',
    show_archived_to_client: 'הראה ארכיון ללקוח',
    show: 'הראה',
    meeting_video: 'הקלטת פגישה',
    still_insufficient_amount_for_buying: 'הצמדת מדד לתשלום בסוף תקופת הבנייה',
    show_explainatory_video: 'הצג סרטון הסבר',
    show_apartments_for: 'הצג דירות עבור',
    show_archived: 'הצג ארכיון',
    difference_between_value_and_price: 'הפרש בין שווי שמאי ומחיר יעד',
    apply_stress_test: 'הפעל מבחן לחץ',
    additional_comments: 'הערות נוספות',
    notes: 'הערות',
    upload: 'העלה',
    upload_files: 'העלאת קבצים',
    reinvestment_and_gradual_selling: 'העברות, תקרות ורצפות',
    transactions: 'העברות',
    transfer_from: 'העבר מ',
    archive: 'העבר לארכיון',
    transfer_to: 'העבר ל',
    hide_zero_rows: 'הסתר שורות ללא תזרים מזומנים',
    hide_explainatory_video: 'הסתר סרטון הסבר',
    hide_all_strategies_from_customer: 'הסתר את כל האסטרטגיות מהלקוח',
    hide: 'הסתר',
    negative_amount_is: 'הסכום השלילי הוא <b>{amount}</b>',
    remaining_amount_trying_asset: 'הסכום הנותר הוא <b>{amount}</b> מנסה נכס <b>{assetName}</b>',
    required_amount_for_margin_is: "הסכום הנדרש לשמירה על דרישות מרג'ין הוא <b>{amount}</b>",
    asset_liquidated_from_to: 'הנכס מונזל מתאריך <b>{date1}</b> עד תאריך <b>{date2}</b>',
    asset_linked_asset_of_loan:
      'הנכס הנוכחי שקשור להלוואה צריך להיות מונזל. שווי מונזל <b>{liquidatedValue}</b> יתרת הלוואה <b>{loanValue}</b>',
    comp_table: 'הנחות יסוד',
    user_has_not_signed_up_yet: 'המשתמש עוד לא נרשם למערכת',
    continue: 'המשך',
    convert_from_another_currency: 'המר ממטבע אחר',
    convert: 'המר',
    customer_shared: 'הלקוח הזה שותף עם המשתמשים',
    customer_not_shared: 'הלקוח הזה לא שותף עם משתמשים נוספים',
    margin_loan_against: 'הלוואת מרג’ין כנגד',
    fixed_income: 'הלוואות חברתיות',
    loan_to_asset: 'הלוואה לנכס',
    loan_against: 'הלוואה כנגד',
    loan: 'הלוואה',
    total_income_from_rent_after_vacancy_and_tax: 'הכנסה כוללת משכירות (לאחר מיסים וvacancy)',
    total_income_from_rent: 'הכנסה כוללת משכירות',
    income: 'הכנסה',
    all: 'הכל',
    holding_postponing_tax: 'הישארות בחברה ודחיית מס',
    register: 'הירשם',
    subtract: 'החסר',
    transfer_applied_to: 'החל על\\ מקור העברה',
    apply: 'החל',
    reapply: 'החל',
    total_monthly_payments: 'החזר משכנתה כולל',
    monthly_mortgage_payment: 'החזר משכנתה חודשי',
    invite_user: 'הזמן משתמש',
    the_weakest_month_and_year: 'הזמן החלש ביותר הוא',
    invite: 'הזמן',
    cleared_linked_loan: 'הורדנו שווי <b>{clearedLoan}</b> מההלוואה הקשורה',
    cleared_linked_loan_remaining_cash:
      'הורדנו שווי  <b>{clearedLoan}</b> מההלוואה הקשורה. יתרת מזומנים <b>{remainingCash}</b>',
    download: 'הורד',
    expenditure: 'הוצאה',
    add_cashflow: 'הוסף תזרים מזומנים',
    update_cashflow: 'הוסף תזרים מזומנים',
    add_new_change: 'הוסף שינוי חדש',
    add_new_cashflow_change: 'הוסף שינוי בתזרים',
    group_add: 'הוסף קבוצתית',
    add_value: 'הוסף ערך',
    add_new_asset: 'הוסף נכס חדש',
    add_asset: 'הוסף נכס',
    buy_asset: 'קנה נכס',
    group_buy_asset: 'קנה נכס קבוצתי',
    add_apartment: 'הוסף נכס',
    add_new_variable: 'הוסף משתנה חדש',
    add_new_admin: 'הוסף מנהל חדש',
    add_new_taxbrackets: 'הוסף מדרגת מס חדשה',
    add_new_customer: 'הוסף לקוח חדש',
    add_new: 'הוסף חדש',
    add_liability: 'הוסף התחייבות',
    add_reinvestment: 'הוסף השקעה תקרות ורצפות',
    add_new_preset: 'הוסף ברירת מחדל חדשה',
    add: 'הוסף',
    buy: 'קנה',
    equity_received: 'הון שהתקבל',
    total_equity_for_buying: 'הון עצמי לרכישה',
    How_much_cash_available_for_deal: 'הון עצמי כולל לעסקה',
    equity_for_taking_mortgage: 'הון עצמי לעיניין לקיחת משכנתה',
    equity_to_assets: 'הון עצמי לנכסים',
    total_equity_to_put_in_the_deal: 'הון עצמי כולל לעסקה',
    equity: 'הון עצמי',
    equity_for: 'הון עצמי',
    required_equity_for_excercising: 'הון נדרש למימוש (סטרייק)',
    app_configuration: 'הגדרות',
    public_signup_config: 'הגדרת הרשמה ציבורית',
    signup_tag: 'תגית הרשמה',
    public_signup_config_hint: 'כל הגדרת הרשמה ציבורית קובעת את ההרשאות שלקוח מקבל כשהוא נרשם דרך הכתובת הזו.',
    add_public_signup_config: 'הוסף הגדרת הרשמה ציבורית',
    edit_public_signup_config: 'עריכת הגדרת הרשמה ציבורית',
    signup_tag_hint: 'דוגמה: / (ברירת מחדל), /<signup_tag>',
    end_day: 'יום סיום',
    end_day_hint: 'ימים לאחר ההרשמה שבהם הרמה משתנה.',
    end_day_and_level_to_together: 'יום סיום ורמת יעד צריכים להיות מוגדרים יחד.',
    end_day_min: 'יום סיום חייב להיות לפחות 1.',
    level_and_level_to_must_differ: 'רמת היעד חייבת להיות שונה מהרמה.',
    signup_tag_taken: 'תגית ההרשמה הזו כבר מוגדרת.',
    signup_tag_not_valid: 'תגית לא תקינה: רווח ו-/ אינם מותרים.',
    public_signup_config_saved: 'הגדרת ההרשמה הציבורית נשמרה.',
    public_signup_config_deleted: 'הגדרת ההרשמה הציבורית נמחקה.',
    delete_public_signup_config_confirm: 'למחוק את הגדרת ההרשמה הציבורית? לא ניתן לבטל פעולה זו.',
    public_signup_config_load_error: 'קישור ההרשמה אינו תקף.',
    public_signup_config_invalid_info: 'אנא השתמשו בקישור הרשמה תקף.',
    no_public_signup_config: 'עדיין אין הגדרת הרשמה ציבורית.',
    select_level: 'בחרו רמה',
    link_copied: 'הקישור הועתק.',
    page_not_found: 'העמוד לא נמצא',
    strategies_archived: 'האסטרטגיות הבאות נשמרו בארכיון!',
    is_rent: 'האם מדובר בשכירות?',
    is_there_an_balcony: 'האם יש מרפסת? פרט',
    is_there_an_elevator: 'האם יש מעלית? פרט',
    is_there_a_safe_room: 'האם יש ממ"ד? פרט',
    is_there_parking: 'האם יש חניה? פרט (בטאבו\\ בשימוש)',
    is_there_garden: 'האם יש גינה? פרט',
    is_only_apartment: 'האם זו דירה יחידה?',
    is_it_the_only_apartment_buying: 'האם זו דירה יחידה במעמד הרכישה?',
    is_it_the_only_apartment_selling: 'האם זו דירה יחידה במעמד המכירה?',
    is_apartment_properly_registered: 'האם הנכס רשום בטאבו? (אם לא פרט)',
    is_there_construction_without_permit: 'האם הכל נבנה בהיתר? (אם לא, פרט לגבי חריגות הבנייה)',
    is_apartment_registered_on_seller_name: 'האם הדירה רשומה על שם המוכר? אם לא אז על שם מי?',
    is_apartment_abroad: 'האם הדירה בחו"ל?',
    willingness_to_buy_complicated_deals: 'האם אתה מוכן לקנות עסקאות מסובכות (מבנים מסוכנים, מושע)',
    willingness_to_buy_floor_3_or_higher_without_elevator:
      'האם אתה מוכן לקנות דירה שנמצאת בקומות הגבוהות של הבניין (+3) ללא מעלית',
    willingess_to_buy_small_apartment: 'האם אתה מוכן לקנות דירה קטנה (פחות מ- 50 מ"ר)',
    are_you_sure_you_want_to_archive_strategy: 'האם אתה בטוח שברצונך לשמור את האסטרטגיה בארכיון?',
    are_you_sure_you_want_to_unarchive_strategy: 'האם אתה בטוח שברצונך להוציא את האסטרטגיה מהארכיון?',
    are_you_sure_you_want_to_unselect_strategy: 'האם אתה בטוח שברצונך לבטל את בחירת האסטרטגיה?',
    are_you_sure_you_want_to_select_strategy: 'האם אתה בטוח שברצונך לבחור באסטרטגיה?',
    liquidation_score: 'דרגת הנזלה',
    rate_from_1_to_10: 'דרג מ-1 עד 10 (1- גרוע 10- מצויין)',
    how_easy_to_find_renters: 'דירוג עד כמה קל למצוא שוכרים לנכס?',
    how_well_maintained: 'דירוג מצב תחזוקת הנכס',
    how_good_is_location: 'דירוג מיקום בעיר',
    how_good_are_current_renters: 'דירוג השוכרים הקיימים (אם יש)',
    linked_apartment: 'דירה מקושרת',
    apartment: 'דירה',
    tenant_stops_paying: 'דייר מפסיק לשלם',
    charts: 'גרפים',
    interest_only: 'גרייס',
    cashflow_appreciation: 'גידול שנתי',
    loan_provider: 'גוף מלווה',
    apartment_size: 'גודל הנכס',
    apartment_size_after_reconstruction: 'גודל אחרי התחדשות',
    loan_value: 'גובה הלוואה',
    new_presets: 'ברירות מחדל חדשות',
    presets: 'ברירות מחדל',
    highest_earner: 'בעל השכר הגבוה יותר',
    balance_with: 'בעזרת העבר ל',
    weakest: 'בנקודה החלשה ביותר',
    yearly_materials_cost_index_rise:
      'בנוסף ייתכן שתהיה או שלא תהיה הצמדה למדד תשומות הבנייה. צריכים מקום לשנות את ערך המדד.',
    balloon: 'בלון',
    home: 'בית',
    unarchiving_strategy: 'ביטול שמירת האסטרטגיה בארכיון',
    unselecting_strategy: 'ביטול בחירה באסטרטגיה',
    disable_reinvestment: 'בטל השקעות מחדש',
    unselect: 'בטל בחירה',
    are_you_sure_you_want_to_delete_taxbrackets: 'בטוח שברצונך למחוק מדרגת מס זו? פעולה זו בלתי הפיכה',
    linked_bank_account_has_no_money: 'בחשבון בנק קשור <b>{accountName}</b> אין כסף',
    password_get_started: 'בחר סיסמא',
    select_unselect_all: 'בחר הכל/בטל בחירה בהכל ',
    select: 'בחר',
    selecting_strategy: 'בחירת אסטרטגיה',
    please_provide_a_primary_bank_account: 'בבקשה בחר חשבון ראשי לאסטרטגיה',
    are_you_sure_you_want_to_unarchive_customer: 'אתה בטוח שברצונך לשחזר את {{שם לקוח}}',
    are_you_sure_you_want_to_delete_cashflow: 'אתה בטוח שברצונך למחוק תזרים מזומנים זה? פעולה זו בלתי הפיכה',
    are_you_sure_you_want_to_delete_asset: 'אתה בטוח שברצונך למחוק נכס זה? פעולה זו בלתי הפיכה',
    are_you_sure_you_want_to_delete_liability: 'אתה בטוח שברצונך למחוק התחייבות זו ? פעולה זו בלתי הפיכה',
    are_you_sure_you_want_to_delete_investment: 'אתה בטוח שברצונך למחוק אפשרות השקעה זו? פעולה זו בלתי הפיכה',
    are_you_sure_you_want_to_delete_one_off_event: 'אתה בטוח שברצונך למחוק אירוע חד פעמי זה? פעולה זו בלתי הפיכה',
    are_you_sure_you_want_to_archive_customer: 'אתה בטוח שברצונך להעביר לארכיון את {{שם לקוח}}?',
    are_you_sure_you_want_to_reapply:
      'אתה בטוח שאתה רוצה לעדכן את הנחות היסוד של האסטרטגיה הזו? אנחנו ממליצים ליצור עותק שלה קודם',
    are_you_sure_you_want_to_delete_admin: 'אתה בטוח שאתה רוצה למחוק את מנהל {admin} אי אפשר לבטל פעולה זו',
    are_you_sure_you_want_to_delete_customer: 'אתה בטוח שאתה רוצה למחוק את לקוח {userName} אי אפשר לבטל פעולה זו',
    are_you_sure_delete_file: 'אתה בטוח שאתה רוצה למחוק את הקובץ ({fileName})? אין דרך חזרה',
    are_you_sure_you_want_to_delete_variable: 'אתה בטוח שאתה רוצה למחוק את המשתנה הזה? אין דרך חזרה',
    are_you_sure_you_want_to_delete_preset: 'אתה בטוח שאתה רוצה למחוק את ברירת המחדל הזו? אין דרך חזרה',
    are_you_sure_you_want_to_delete_strategy: 'אתה בטוח שאתה רוצה למחוק את אסטרטגיה {strategy} אי אפשר לבטל פעולה זו',
    are_you_sure_reset_comp_table: 'אתה בטוח שאתה רוצה לאפס את הטבלה הזו? אין דרך חזרה',
    confirm_password: 'אשר סיסמא',
    show_password: 'הצג סיסמה',
    hide_password: 'הסתר סיסמה',
    strategy_archive: 'ארכיון אסטרטגיות',
    archived: 'ארכיון',
    reset_to_default: 'אפס לברירת מחדל',
    strategies: 'אסטרטגיות',
    new_strategy: 'תוכנית חדשה',
    strategy: 'אסטרטגיה',
    anona: 'אנונה',
    please_provide_a_primary_bank_account_for_this_strategy: 'אנא ספק חשבון בנק ראשי לאסטרטגיה זו',
    please_fill_the_form_to_continue: 'אנא מלא את הטופס כדי להמשיך',
    alphabetically: 'אלפבתי',
    real_estate_full_service: 'איתור נדל”ן',
    add_customer_profile: 'הוסף פרופיל לקוח',
    edit_customer_profile: 'ערוך פרופיל לקוח',
    how_to_fill_out_a_property_profile: 'כיצד למלא פרופיל נכס',
    customer_profile: 'פרופיל לקוח',
    reset_zoom: 'איפוס גודל תצוגה',
    no_name: 'אין שם',
    no_files_to_show: 'אין קבצים עדיין!',
    no_asset: 'אין נכס',
    margin_not_met: "אין מספיק יתרה לעמוד במרג'ין עבור נכס  {stockType} והלוואה <b>{loanName}</b> בתאריך <b>{date}</b>",
    nothing_to_show: 'אין מה להראות!',
    nothing_to_show_type_to_search: 'אין מה להראות. הקלידו בתיבת החיפוש כדי לראות אפשרויות.',
    no_matching_options_found: 'לא נמצאו אפשרויות תואמות!',
    search_options_here: 'חפשו אפשרויות כאן',
    all_options_selected: 'כל האפשרויות נבחרו',
    n_options_selected: '{count} אפשרויות נבחרו',
    newest_first: 'החדש ביותר תחילה',
    oldest_first: 'הישן ביותר תחילה',
    no_incomes: 'אין הכנסות',
    no_expenditure: 'אין הוצאות',
    no_email: 'אין אימייל',
    recipient_emails: 'אימיילים נמענים',
    secondary_email: 'אימייל נוסף',
    email: 'אימייל',
    other: 'אחר',
    mortgage_percentage: 'אחוזי מימון על הנכס הנרכש',
    percentage: 'אחוז',
    problems_detected: 'אותרו בעיות',
    appraised_value: 'אומדן שווי שמאי',
    crash_percentage: 'אובדן שווי במשבר',
    loses_place_of_work: 'אובדן מקום עבודה',
    showing_n_items: '{n} פריטים',
    additional_costs_lawyer_apraiser: 'עלויות נלוות (עו"ד, שמאי וכו\')',
    real_estate_holding_period_months: 'תקופת החזקה בנדל"ן (חודשים)',
    name_optional: 'שם (אופציונלי)',
    welcome_message: 'ברוכים הבאים לאתיקה פיננסים',
    public_signup: 'צור חשבון',
    public_signup_heading: 'צור חשבון',
    public_signup_intro_hint: 'לאחר שליחת הטופס תקבלו אימייל עם קישור הזמנה להגדרת הסיסמה.',
    signup_success_verify_email:
      'החשבון נוצר. בדקו את תיבת האימייל שלכם לקבלת קישורים לאימות האימייל ולהגדרת הסיסמה, ולאחר מכן התחברו.',
    phone_number_public_signup: 'טלפון',
    name_required_short: 'נא להזין שם.',
    phone_required_short: 'נא להזין מספר טלפון.',
    invalid_email_short: 'נא להזין כתובת אימייל תקינה.',
    signup_brand_headline: 'שלום וברוכים הבאים לאתיקה פיננסים!',
    signup_brand_tagline: 'בונים בהירות לעתיד הפיננסי שלכם.',
    signup_all_fields_required: 'כל השדות נדרשים.',
    login_brand_headline: 'שוב ברוכים הבאים לאתיקה פיננסים',
    login_brand_tagline: 'התחברות מאובטחת לסביבת תכנון העושר שלכם.',
    reset_password_brand_headline: 'בחרו סיסמה חדשה',
    reset_password_brand_tagline: 'אבטחו את החשבון בסיסמה חזקה—מיד לאחר מכן תתחברו.',
    get_started_brand_headline: 'התחילו עם אתיקה פיננסים',
    get_started_brand_tagline: 'שתפו את הפרטים ונשלח אליכם קישור ליצירת סיסמה.',
    costs: 'עלויות',
    realtor_cost_for: 'עלות מתווך עבור',
    renovation_cost_for: 'עלות שיפוץ עבור',
    buying_tax_calculated_automatically: 'מס רכישה מחושב אוטומטית?',
    selling_tax_calculated_automatically: 'מס מכירה מחושב אוטומטית?',
    estimated_time_for_finishing_contruction_from_demolition_months: 'זמן משוער לסיום בנייה ממועד ההריסה (חודשים)',
    estimated_time_for_demolition_month: 'זמן משוער להריסה (חודש)',
    logging_in: 'מתחבר',
    creating_account: 'יוצר חשבון',
    please_wait: 'אנא המתן...',
    value_in_currency: 'ערך ב-{currency}',
    welcome_to_ETICA_crm: 'שלום! ברוכים הבאים ל-ETICA CRM',
    contacts: 'אנשי קשר',
    comments: 'הערות',
    contracts: 'חוזים',
    inbounds: 'נכנסים',
    emails: 'אימיילים',
    phone_calls: 'שיחות טלפון',
    no_comments_to_show: 'אין הערות להציג!',
    no_contracts_to_show: 'אין חוזים להציג!',
    type_your_comment_here: 'הקלד את ההערה שלך כאן...',
    reset: 'איפוס',
    are_you_sure_delete_comment: 'האם אתה בטוח שברצונך למחוק את ההערה הזו? פעולה זו אינה ניתנת לביטול',
    admin: 'מנהל',
    products: 'מוצרים',
    add_new_product: 'הוסף מוצר חדש',
    update_product: 'עדכן מוצר',
    price: 'מחיר',
    template_link: 'קישור לתבנית ב-Prospero',
    are_you_sure_you_want_to_delete_products:
      'האם אתה בטוח שברצונך למחוק את המוצר ({productName})? פעולה זו אינה ניתנת לביטול',
    send_new_contract: 'שלח חוזה חדש',
    edit_and_send_contract: 'ערוך ושלח',
    send: 'שלח',
    quote: 'ציטוט',
    anona_monthly_payment: 'תשלום חודשי אנונה',
    copy_apartment: 'העתק דירה',
    copy: 'העתק',
    select_customer_to_copy_apartment: 'בחר לקוח להעתקת הדירה אליו',
    select_customer: 'בחר לקוח',
    view_as_client: 'צפה כלקוח',
    interested_in_my_course: 'מעוניין בקורס שלי',
    creating_user: 'יוצר משתמש',
    undo: 'בטל',
    redo: 'בצע שוב',
    are_you_sure_archive: 'האם אתה בטוח שברצונך לארכב?',
    whatsapp: 'וואטסאפ',
    example_user: 'משתמש לדוגמה',
    example_open: 'דוגמה',
    customer_not_found: 'לקוח לא נמצא',
    info_about_the_neighborhood: 'מידע על השכונה',
    transportation: 'תחבורה',
    parking: 'חניה',
    physical_condition: 'מצב פיזי',
    dangerous_building: 'בניין מסוכן?',
    number_of_air_directions: 'מספר כיווני אוויר',
    developer_company: 'חברת פיתוח',
    developer_website: 'אתר חברת הפיתוח',
    signature_percentage: 'אחוז חתימה',
    show_liqudation_table_to_client: 'הצג טבלת הנזלה ללקוח?',
    show_extreme_case_to_client: 'הצג מקרה קיצון ללקוח?',
    show_cashflow_impact_to_client: 'הצג השפעת תזרים מזומנים ללקוח?',
    show_cushion_to_client: 'הצג כרית ללקוח?',
    import: 'ייבוא',
    need_help_email_us: 'צריך עזרה? שלח לנו אימייל',
    update_strategy_time: 'עדכן זמן אסטרטגיה',
    updating_strategy_time: 'מעדכן זמן אסטרטגיה',
    email_get_started: 'אימייל (ישמש לכניסה מחדש)',
    create_password_title: 'צור סיסמה',
    create_password_subtitle: 'תועבר לדף הכניסה לאחר מכן',
    hello: 'שלום!',
    submit: 'שלח',
    Send_Password_Reset_Link: 'שלח קישור לאיפוס סיסמא',
    sending: 'שולח...',
    salesperson: 'איש מכירות',
    financial_strategist: 'אסטרטג פיננסי',
    real_estate_analyst: 'אנליסט נדל"ן',
    crm_details: 'פרטי CRM',
    this_customer_is_linked: 'לקוח זה מקושר עם איש הקשר הבא ב-CRM',
    matching_contact_found: 'נמצא איש קשר תואם ב-CRM. הלקוח יקושר לאיש הקשר הבא.',
    break_down: 'פירוט',
    phone: 'טלפון',
    deposits: 'הפקדות',
    partial_sales: 'מכירות חלקיות',
    general: 'כללי',
    drive: 'כונן',
    close_drive: 'סגור תיקיית כונן',
    open_drive: 'פתח תיקיית כונן',
    click_to_create_folder: 'לחץ כאן כדי ליצור תיקייה',
    creating_drive_folder: 'יוצר תיקיית כונן...',
    are_you_sure_to_delete_this_file: 'האם אתה בטוח שברצונך למחוק קובץ זה?',
    profile: 'פרופילים',
    are_you_sure_you_want_to_delete_apartment_profile: 'האם אתה בטוח שברצונך למחוק פרופיל דירה זה?',
    lock_profile_edit: 'נעל עריכת פרופיל',
    unlock_profile_edit: 'בטל נעילת עריכת פרופיל',
    are_you_sure_you_want_to_lock_profile_edit: 'האם אתה בטוח שברצונך לנעול פרופיל זה? לקוחות לא יוכלו לערוך אותו.',
    are_you_sure_you_want_to_unlock_profile_edit:
      'האם אתה בטוח שברצונך לבטל את נעילת הפרופיל? לקוחות יוכלו לערוך אותו.',
    profile_approved_cannot_updated: 'פרופיל זה אושר על ידי ניהול ולא ניתן לערוך אותו',
    profile_not_submitted_for_approval: 'פרופיל זה עדיין לא נשלח לאישור. כל הפעולות מושבתות.',
    created_by_customer: 'נוצר על ידי הלקוח',
    approve: 'לְאַשֵׁר',
    grant_month: 'חודש הענקה',
    grant_year: 'שנת הענקה',
    vesting_month: 'חודש הבשלה',
    vesting_year: 'שנת הבשלה',
    stock_value: 'ערך מניה',
    initial_stock_value: 'ערך מניה התחלתי',
    marginal_tax: 'מס שולי',
    holding_period: 'תקופת החזקה',
    required_cash_for_deal: 'מזומן נדרש לעסקה',
    developer_loan: 'הלוואת מפתח',
    linear_payment: 'תשלום לינארי',
    developer_company_scale: 'קנה מידה של חברת הפיתוח',
    buying_decision_scale: 'האם העסקה חייבת להיסגר מהר מאוד?',
    large_scale_renovation: 'האם הדירה דורשת שיפוץ משמעותי?',
    early_stage_deals: 'עסקאות בשלב מוקדם',
    has_3_floor_or_higher_without_elevator: 'יש 3 קומות או יותר ללא מעלית',
    complicated_deals: 'עסקאות מסובכות',
    profile_fields: 'שדות פרופיל',
    continue_after_sell: 'המשך לאחר מכירה?',
    after_tax: 'לאחר מס?',
    reset_password: 'איפוס סיסמה',
    token_expired_invalid: 'קישור האיפוס אינו תקף או שפג תוקפו',
    token_expired_info: 'אנא בקשו קישור חדש לאיפוס הסיסמה.',
    go_to_login_page: 'לחץ כאן כדי לעבור לדף הכניסה',
    show_rujum: "הצג רוג'ום",
    rujum: "רוג'ום",
    resend_password_link: 'שלח מחדש קישור לאיפוס סיסמא',
    resend_reset_link_modal_hint:
      'הזינו את כתובת האימייל של חשבון אתיקה. אם היא קיימת במערכת, נשלח אליכם קישור איפוס חדש.',
    resend_reset_link_error: 'משהו השתבש. נסו שוב.',
    field_required: 'שדה זה נדרש',
    others: 'אחרים',
    board_name: 'שם לוח',
    update_one_off_event: 'עדכן אירוע חד פעמי',
    add_one_off_event: 'הוסף אירוע חד פעמי',
    new_one_time_event: '+ אירוע חד פעמי חדש',
    search_by_event_name: 'חיפוש לפי שם האירוע',
    action_type: 'סוג פעולה',
    asset_or_liability: 'נכס או התחייבות',
    update_asset: 'עדכן נכס',
    assey: 'נכס',
    CREATE: 'צור',
    UPDATE: 'עדכן',
    created_this_user_on: 'יצר משתמש זה בתאריך',
    made_following_changes_on: 'ביצע את השינויים הבאים בתאריך',
    new_apartment: 'דירה חדשה',
    gush_helka_tat_helka: 'גוש חלקה תת חלקה',
    created_at: 'נוצר בתאריך',
    update_apartment: 'עדכן דירה',
    viewing_matching_customers: 'צפה בלקוחות תואמים',
    gush_tat_helka: 'גוש תת חלקה',
    related_customers: 'לקוחות קשורים',
    no_matching_customer_found: 'לא נמצא לקוח תואם',
    customers_matching_this_apartment: 'לקוחות תואמים לדירה זו',
    open_google_drive: 'פתח גוגל דרייב',
    drop_your_files_here: 'גרור את הקבצים שלך לכאן',
    autofill: 'מילוי אוטומטי',
    autofill_remaining_payment: 'מילוי אוטומטי של יתרת התשלום ({remainingPayment})',
    willingness_for_mixed_population: 'האם אתה מוכן לקנות דירה באיזור עם אוכלוסיה מעורבת?',
    change_asset_name_confirm: 'האם אתה בטוח שברצונך לשנות את שם הנכס? זה ינתק את הנכס מאסטרטגיות אחרות',
    private_company: 'חברה פרטית',
    public_company: 'חברה ציבורית',
    company_type: 'סוג החברה',
    change_liability_name_confirm:
      'האם אתה בטוח שברצונך לשנות את שם ההתחייבות? פעולה זו תנתק את ההתחייבות מאסטרטגיות אחרות.',
    lawyer: 'עוֹרֵך דִין',
    mortgage_broker: 'יועץ משכנתאות',
    template_name: 'שם תבנית',
    template_body: 'גוף תבנית',
    sandbox_mode: 'מצב ארגז חול',
    new_sandbox: 'ארגז חול חדש',
    sandbox: 'ארגז חול',
    no_strategy_selected: 'לא נבחרה אסטרטגיה. אנא בחר/הוסף אסטרטגיה לצפייה',
    sandboxes: 'סביבות ניסוי',
    differences: 'הבדלים',
    show_sandbox_strategies: 'אסטרטגיות ארגז חול',
    select_parent_strategy: 'בחר אסטרטגיית הורה',
    add_strategy_to_compare: 'הוסף אסטרטגיה להשוואה',
    nothing_to_show_compare_strategy: 'אין מה להציג עדיין, בחר לפחות שתי אסטרטגיות להשוואה!',
    deleted: 'נמחק',
    added: 'נוסף',
    updated: 'עודכן',
    show_differences: 'הצג הבדלים',
    main: 'עיקרי',
    buyer: 'קוֹנֶה',
    click_to_unmark_as_buyer: 'לחץ כדי לבטל את הסימון כקונה',
    click_to_mark_as_buyer: 'לחץ כדי לסמן כקונה',
    confirm_unmark_buyer: 'האם אתה בטוח שברצונך להסיר את הלקוח כרוכש?',
    confirm_mark_buyer: 'האם אתה בטוח שברצונך לסמן את הלקוח כרוכש?',
    available: 'זמין',
    bought_by_our_client: 'נקנה על ידי הלקוח שלנו',
    bought_by_outsider: 'נקנה על ידי גורם חיצוני',
    hot: 'חם',
    move_to_sandbox: 'העבר לארגז חול',
    move_to_mainbox: 'העבר לתיבה ראשית',
    strategy_transfer: 'העברת אסטרטגיה',
    are_you_sure_to_move_this_strategy_to_mainbox: 'האם אתה בטוח שברצונך להעביר אסטרטגיה זו לתיבה הראשית?',
    are_you_sure_to_move_this_strategy_to_sandbox: 'האם אתה בטוח שברצונך להעביר אסטרטגיה זו לארגז החול?',
    move: 'לְהַעֲבִיר',
    strategy_name_exists: 'אסטרטגיה עם שם זה כבר קיימת בתיבה היעד. אנא הזן שם חדש.',
    enter_new_strategy_name: 'הזינו שם לאסטרטגיה החדשה',
    generate_report: 'צור דוח',
    generate: 'צור',
    generating_report: 'ייצור דוח...',
    view_report: 'צפה בדוח',
    apartment_report: 'דוח דירה',
    select_report_template: 'בחר תבנית דוח',
    saving: 'שומר...',
    regenerate_report: 'שחזור דוח',
    confirm_regenerate_report: 'האם אתה בטוח שברצונך לשחזר את הדוח? פעולה זו תחזיר את הדוח למצבו המקורי.',
    regenerate_report_progress: 'שחזור דוח...',
    updating: 'מעדכן...',
    start_new_meeting: 'התחיל פעילות חדשה',
    confirm_start_new_meeting: 'האם אתה בטוח שברצונך להתחיל פעילות חדשה?',
    start_meeting: 'התחיל פעילות',
    starting_meeting: 'מתחיל פעילות...',
    join_meeting: 'הצטרף לפעילות',
    deleting: 'מחק...',
    delete_report_alert: 'האם אתה בטוח שברצונך למחוק את הדוח? פעולה זו אינה ניתנת לביטול.',
    report: 'דוח',
    report_is_in_draft_mode: 'פרסם את הדוח כדי לשתף',
    publish_report_alert: 'האם אתה בטוח שברצונך לפרסם דוח זה? פעולה זו תשבית את מצב העריכה.',
    unpublish_report_alert: 'האם אתה בטוח שברצונך להחזיר דוח זה למצב טיוטה? פעולה זו תאפשר את מצב העריכה.',
    publish: 'פרסם',
    mark_as_draft: 'סמן כטיוטה',
    uneditable_report: 'הדוח אינו ניתן לעריכה. סמן כטיוטה כדי לערוך.',
    published: 'פורסם',
    draft: 'טיוטה',
    assigned_to: 'מוקצה אל',
    hide_sidebar: 'הסתר סרגל צד',
    show_sidebar: 'הצג סרגל צד',
    edit_variable: 'עריכת משתנה',
    insert: 'הכנס',
    regenerate: 'צור מחדש',
    regenerated_value: 'ערך שנוצר מחדש',
    update_prompt_to_generate_new_value: 'עדכן את ההנחיה ליצירת ערך חדש',
    current_value: 'ערך נוכחי',
    prompt: 'הנחיה',
    document_variables: 'משתני מסמך',
    search_variables: 'חיפוש משתנים...',
    no_variables_found: 'לא נמצאו משתנים',
    cancel: 'ביטול',
    send_invitation_to_customer: 'שלח הזמנה ללקוח',
    fill_placeholder: 'מילוי מקום פנוי',
    app_configs: 'הגדרות אפליקציה',
    save_and_close: 'שמור וסגור',
    save_and_publish_for_review: 'שמור ובקש אישור',
    publish_for_review: 'בקש אישור',
    edit_category_name: 'עריכת שם קטגוריה',
    enter_category_name: 'הזן שם קטגוריה',
    calc_category: 'קטגוריה',
    shared_ownership: 'כונס נכסים',
    dangerous_building: 'דירת יורשים',
    heirs_apartment: 'מבנה מסוכן',
    receivership: 'מושע',
    irrelevant: 'לא רלוונטי',
    max_negative_cash_flow: 'תזרים שלילי מקסימלי לעסקה',
    prompt_context: 'הקשר של דוח דירה',
    additional_prompt_context: 'פרומפט נוסף',
    system_prompt_context: 'פרומפט מערכת',
    edit_prompt_context: 'ערוך קשר מטלה',
    report_updated_successfully: 'דוח עודכן בהצלחה',
    error_updating_report: 'שגיאה בעדכון דוח',
    in_active_search: 'בחיפוש אקטיבי',
    on_hold: 'בהקפאה',
    linked_apartment: 'דירה מקושרת',
    please_select_matching_profiles: 'אנא בחר את הפרופילים המתאים',
    relative: 'קשר יחסי',
    relative_down: 'קשר יחסי מטה',
    no_matching_profiles: 'לא נמצאו פרופילים תואמים ללקוח',
    add_additional_field_info: 'הוסף מידע נוסף',
    edit_additional_field_info: 'ערוך מידע נוסף',
    info: 'מידע',
    clear_notes: 'נקה הערה',
    add_note: 'הוסף הערה',
    add_your_notes_here: 'הוסף שינויים שלך כאן...',
    bought_date: 'תאריך קנייה',
    assignment_date: 'תאריך שיוך',
    terminal_value: 'ערך סופי',
    need_help_talk_to_us: 'שאלות? הצעות? דברו איתנו!',
    email_us: 'אימייל',
    whatsapp_us: 'וואטסאפ',
    in_progress: 'במעקב',
    bought_by_our_client_new: 'נקנה ע"י לקוח שלנו',
    are_you_sure_you_want_to_change_the_status_of_this_apartment: 'אתה בטוח שברצונך לשנות את סטטוס הדירה?',
    field_name: 'שם השדה',
    edit_multiple_apartment_field: 'ערוך דירות קבוצתית',
    project_stage: 'שלב תכנוני',
    declaration_of_an_urban_renewal_complex: 'הכרזת מתחם התחדשות עירונית',
    election_of_tenant_representatives: 'בחירת נציגות דיירים',
    choosing_a_tenant_attorney_to_conduct_a_developer_tender: 'בחירת עו"ד דיירים לביצוע מכרז יזמים',
    choosing_an_entrepreneur: 'בחירת יזם',
    formulation_of_a_renewal_agreement: 'גיבוש הסכם התחדשות',
    examining_planning_alternatives_in_the_local_committee: 'בחינת חלופות תכנוניות בועדה המקומית',
    receiving_the_local_committees_recommendation: 'קבלת המלצת הועדה המקומית',
    majority_required_67_percent: 'רוב דרוש 67%',
    submitting_a_city_building_plan_taba_to_a_district_committee: 'הגשת תכנית בניין עיר (תב"ע) לועדה מחוזית -',
    depositing_a_planning_application_for_objections: 'הפקדת תב"ע להתנגדויות',
    the_urban_development_plan_takes_effect_change_in_the_urban_development_plan: 'תב"ע מקבלת תוקף (שינוי תב"ע)',
    architectural_plan: 'תוכנית אדריכלית',
    submitting_a_permit_application_to_the_local_committee: 'הגשת בקשה להיתר בועדה המקומית',
    permit_with_conditions_and_start_of_free_sale: 'היתר בתנאים ותחילת פריסייל',
    tenant_evacuation_notice: 'הודעת פינוי דיירים',
    excavation_and_landfill_permit: 'היתר חפירה ודיפון',
    approval_to_start_work: 'אישור תחילת עבודות',
    building_permit: 'היתר בניה',
    opening_a_banking_account: 'פתיחת ליווי בנקאי',
    replace: 'החלף',
    no_address: 'אין כתובת',
    are_you_sure_you_want_to_update_this_apartment: 'אתה בטוח שברצונך לעדכן את הדירה?',
    preparing_contract: 'בטיוטות',
    email_already_in_use: 'האימייל הזה כבר בשימוש',
    related_deal: 'עסקה קשורה',
    signed: 'נחתם',
    deal_finished: 'עסקה הסתיימה',
    published: 'נוצר בפרוספרו',
    sent: 'נשלח',
    opened: 'נפתח',
    declined: 'נדחה',
    contract_not_needed: 'לא נדרש הסכם',
    quitted: 'פרש מתהליך',
    client_info: 'מידע לקוח',
    recordings: 'הקלטות',
    strategist_strategies: 'התוכניות של האסטרטג',
    diy_strategies: 'התוכניות שלי',
    strategy_summary: 'סיכום תוכנית',
    repeating_changes: 'שינויים חוזרים',
    one_time_events: 'אירועים חד פעמיים',
    graphs: 'גרפים',
    summary_of_actions: 'סיכום פעולות',
    archive_client: 'העבר לקוח לארכיון',
    unarchive_client: 'שחזר לקוח',
    client_comp_table: 'הנחות יסוד',
    update_group_strategies: 'עדכן אסטרטגיות קבוצתית',
    delete_client: 'מחק לקוח',
    settings: 'הגדרות',
    gathering_info: 'איסוף נתונים',
    assigned: 'שויך',
    advanced_check: 'בדיקות מתקדמות',
    preparing_contract: 'טיוטות',
    bought: 'נקנה',
    didnt_close: 'לא סגר',
    are_you_sure_you_want_to_delete_this_group:
      '⁠אתה בטוח שאתה רוצה למחוק את קבוצת השאלות? הפעולה הזו לא ניתנת לשיחזור.',
    add_group: '⁠הוסף קבוצה',
    add_question: 'הוסף שאלה',
    title: 'כותרת',
    questions: 'שאלות',
    question_groups: 'קבוצת שאלות',
    group_name: '⁠שם קבוצה',
    footer: '⁠חלק עליון',
    short: 'קצר',
    long: 'ארוך',
    no_groups_created_yet: '⁠לא נוצרו עדיין קבוצות. לחץ ״הוסף קבוצה״ כדי להתחיל.',
    pension: 'פנסיה',
    rsu: 'RSU',
    created_by_client: 'נוצרה על ידי הלקוח',
    chosen_strategy: 'האסטרטגיה שנבחרה',
    show_more: 'הראה עוד...',
    show_less: 'הראה פחות...',
    no_any_logs: 'אין לוגים להצגה',
    default_mode: 'מצב ברירת מחדל',
    duplicate_apartment: 'העתק דירה',
    duplicate_apartment_alert: 'האם אתה בטוח שברצונך להעתיק את הדירה? פעולה זו תצור דירה חדשה עם אותם פרטים.',
    confirm_archive_apartment_text: 'האם אתה בטוח שברצונך לארכב את הדירה?',
    confirm_unarchive_apartment_text: 'האם אתה בטוח שברצונך לשחזר את הדירה?',
    archiving_apartment: 'מעביר לארכיון...',
    unarchiving_apartment: 'משחזר מהארכיון...',
    apartment_archived_success: 'הדירה נשמרה בארכיון בהצלחה',
    apartment_unarchived_success: 'הדירה שוחזרה מהארכיון בהצלחה',
    do_you_want_to_archive_the_apartment: 'האם אתה רוצה להעביר את הדירה לארכיון?',
    do_you_want_to_unarchive_the_apartment: 'האם אתה רוצה לשחזר את הדירה מהארכיון?',
    export_csv: 'יצא כ-CSV',
    advanced_check_date: 'תאריך בדיקות מתקדמות',
    did_not_close_date: 'תאריך לא סגור',
    starting_profit: 'רווח התחלתי',
    tax_on_profit: 'מס על הרווח',
    table_view: 'צפה בטבלה',
    group_view: 'צפה בקבוצות',
    total_investment_made_so_far: 'השקעה כוללת',
    appreciation_value_so_far: 'עליית ערך כוללת',
    january: 'ינואר',
    february: 'פברואר',
    march: 'מרץ',
    april: 'אפריל',
    may: 'מאי',
    june: 'יוני',
    july: 'יולי',
    august: 'אוגוסט',
    september: 'ספטמבר',
    october: 'אוקטובר',
    november: 'נובמבר',
    december: 'דצמבר',
    jan: "ינו'",
    feb: "פבר'",
    mar: "מרץ'",
    apr: "אפר'",
    jun: "יונ'",
    jul: "יול'",
    aug: "אוג'",
    sep: "ספט'",
    oct: "אוק'",
    nov: "נוב'",
    dec: "דצמ'",
    all_users: 'כל הלקוחות',
    show_archived_customers: 'הצג לקוחות בארכיון',
    hide_archived_customers: 'הסתר לקוחות בארכיון',
    min: 'מ-',
    max: 'עד',
    select_all: 'בחר הכול',
    n_cities_selected: 'נבחרו עוד {count} ערים',
    n_city_selected: 'נבחרה עוד {count} עיר',
    no_related_deals: 'אין עסקאות משויכות ללקוח',
    no_options: 'אין אפשרויות',
    switch_to_manual_mode: 'מעבר למצב ידני',
    switch_to_auto_mode: 'מעבר למצב אוטומטי',
    expected_selling_tax: 'מס שבח צפוי',
    upto: 'עד',
    asset_value_at_selling_month_and_year: 'שווי הנכס בחודש ובשנת המכירה',
    phone_numbers: 'מספרי טלפון',
    select_one: 'בחרו',
    select_one_ellipsis: 'בחרו...',
    read_only: 'קריאה בלבד',
    trial: 'ניסיון',
    basic: 'בסיסי',
    full_access: 'גישה מלאה',
    premium: 'פרימיום',
    enter_questions_title: 'הזינו כותרת',
    enter_questions_description: 'הזינו תיאור',
    enter_group_name: 'הזינו שם קבוצה',
    enter_question_text: 'הזינו את נוסח השאלה',
    enter_footer_text: 'הזינו טקסט תחתון',
    edit_calculator: 'עריכת מחשבון',
    sort_desc: '(מהחדש לישן)',
    sort_asc: '(מהישן לחדש)',
    save_changes: 'שמירת שינויים',
    okay: 'אישור',
    open: 'פתיחה',
    previous: 'הקודם',
    next: 'הבא',
    loading: 'טוען...',
    uploading_please_wait: 'מעלה קבצים, נא להמתין...',
    click_or_drag_and_drop_files_here: 'לחצו או גררו לכאן קבצים',
    no_files_uploaded: 'לא הועלו קבצים',
    no_preview_to_show: 'אין תצוגה מקדימה',
    no_data_available: 'אין נתונים',
    no_strategies_to_show: 'אין אסטרטגיות להצגה',
    no_profiles_found: 'לא נמצאו פרופילים',
    no_customers_selected: 'לא נבחרו לקוחות',
    no_any_customers_selected: 'לא נבחרו לקוחות',
    selected_customers: 'לקוחות נבחרים',
    no_customers_to_show: 'אין לקוחות להצגה',
    leverage_options: 'אפשרויות מינוף',
    view_leverage_options: 'הצג אפשרויות מינוף',
    max_leverage_allowed: 'מינוף מקסימלי מותר',
    rem_leverage: 'יתרת מינוף',
    amount: 'סכום',
    shekels: 'שקלים',
    update_investments: 'עדכון השקעות',
    update_multiple_strategies: 'עדכון קבוצתי של אסטרטגיות',
    filter: 'סינון',
    empty: 'ריק',
    hebrew_name: 'שם בעברית',
    english_name: 'שם באנגלית',
    n_actions: '{count} פעולות',
    n_action: '{count} פעולה',
    tax_percent: 'מס (%)',
    calculator: 'מחשבון'
  }
};

export const languageOptions = Object.keys(languageContent);

export const getActiveLanguage = () => {
  return localStorage.getItem('language') || 'Hebrew';
};

export const setActiveLanguage = (lang = 'English') => {
  return localStorage.setItem('language', lang);
};

export const isRtl = language => {
  return language === 'Hebrew';
};

export const MONTH_FULL_KEYS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december'
];

export const MONTH_SHORT_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export const getTranslatedMonth = (translate, monthIndex, { short = false } = {}) => {
  const keys = short ? MONTH_SHORT_KEYS : MONTH_FULL_KEYS;
  const key = keys[monthIndex];
  return (key && translate(key)) || '';
};
